import React, { useEffect, useState, useRef, useContext } from "react";
import { useParams } from "react-router-dom";
import Audioplayer from "./Audioplayer";
import Studyplanner from "./StudyPlanner";
import ChatBubble from "./ChatBubble";
import ChatInput from "./ChatInput";
import Trendingcurrentaffairs from "./TrendingCurrentAffairs";
import Relatedtopic from "./RelatedTopics";
import McqPractice from "./McqPractice";
import "../ChatWindow.css";
import "../assets/css/style.css";
import "../assets/css/loading-animation.css";
import { uploadPdfService } from "../services/Evaluation";
import Tooltip from "./CustomTooltip";
import mermaid from "mermaid";
import invokeChainAPI from "../services/chatApi";
import { revisePyq } from "../services/toolKit";
import prepareMentorMindResponse, {
  normalizeCards,
  normalizeKeywordsHtml,
  extractKeywordsFromHtml,
  cleanKeywordLabel,
  extractEnrichmentSections,
} from "../utils/mentorMindResponse";
import {
  getSuggestedQuestions,
  searchPrompts,
} from "../services/getSuggestedQuestions";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import html2pdf from "html2pdf.js";
import submitFeedback from "../services/feedbackApi";
import watermarkImage from "../assets/images/logo/SVG/Logo-Org.svg";
import pdfHeaderLogo from "../assets/images/pdfHeaderLogo.svg";
import { refreshTokens } from "../services/authenticationServices";
import { findimages, findNewImages } from "../services/getImages";
import { AuthContext } from "../Hook/AuthProvider";
import Tourpoup from "./Tourpoup";
import { useNavigate, useLocation } from "react-router-dom";
import McqResponse from "./McqResponce";
import Mainspractice from "./Mainspractice";
import Skeleton from "react-loading-skeleton";
import { InfographicTab, ImageGallery } from "./TabbedPopup";
// import relatedTopicsData from '../../public/data/relatedTopics.json';
import {
  getProfile,
  logoutUser,
  updateUserDetails,
} from "../services/authenticationServices";
import getRelatedTopics, { getRelatedSummaries } from "../services/relatedTopicsService";
import searchMcqs from "../services/mcqSearchService";
import { getSubjects } from "../services/mcqApi";
import { applyReferralCode } from "../services/referalServices";
import getSyllabusProgressDetail from "../services/syllabusProgressService";
import { use, useCallback } from "react";
import { reverse } from "d3";

const predefinedPrompts = [
  {
    // Model Answer : See a Model Answer
    label: "See a Model Answer",
    description: "To 'Why labor force...'",
    value: "See a Model Answer",
    image: "/assets/images/model-ans.svg",
  },
  // {
  //   label: "Practice MCQ",
  //   description: "To 'Why labor force...'",
  //   value: "Practice MCQ",
  //   image: "assets/images/mcq-p.svg",
  // },

  {
    //  Essay Guidance : Frame Your Essay
    label: "Frame Your Essay",
    description: "The ship in the harbor is safe, but...",
    value: "Frame Your Essay",
    image: "/assets/images/eassy-guidance-new.svg",
  },
  {
    //  Short Notes : Quick Topic Summary
    label: "Quick Topic Summary",
    description: "Short Notes on 'plate tectonics'",
    value: "Quick Topic Summary",
    image: "/assets/images/short-notes.svg",
  },
  {
    //  Case Study : Explore a Case Study
    label: "Explore a Case Study",
    description: "Case Study on 'Digital Divide'",
    value: "Explore a Case Study",
    image: "/assets/images/cas-study2.svg",
  },
  // {
  //   //  Approach : Plan Your Answer
  //   label: "Plan Your Answer",
  //   description: "To 'Why labor force...'",
  //   value: "Plan Your Answer",
  //   image: "assets/images/approach1.svg",
  // },
  {
    label: "PYQ Mains",
    description: "PYQs on Industrial Growth",
    value: "PYQ Mains",
    image: "/assets/images/model-ans.svg",
  },
  {
    label: "PYQ Prelims",
    description: "PYQs on Biodiversity",
    value: "PYQ Prelims",
    image: "/assets/images/info.svg",
  },
  // {
  //   label: "Practice MCQ",
  //   description: "Related to Economy, Polity, or Geography",
  //   value: "Practice MCQ",
  //   image: "assets/images/write-pad.svg",
  // },
  {
    label: "Evaluate",
    description: "Why labor force participation",
    value: "Evaluate",
    image: "/assets/images/write-pad.svg",
  },
  {
    label: "Mains Practice",
    description: "On 'Why labor force...'",
    value: "Mains Practice",
    image: "/assets/images/write-pad.svg",
  },
];

const extractSubjectFromTheme = (theme) => {
  if (typeof theme !== "string") return null;

  const normalizedTheme = theme.trim();
  if (!normalizedTheme) return null;

  return normalizedTheme.split("|")[0]?.trim() || null;
};

const LOADING_STEPS_GENERIC = [
  "Generating your answer...",
  "Understanding your question...",
  "Question understood",
  "Cross-checking facts across multiple UPSC resources...",
  "Relevant sources identified",
  "Balancing facts, analysis, and exam relevance...",
  "Identifying keywords relevant for Prelims and Mains...",
  "Drafting response...",
];

const LOADING_STEPS_ESSAY = [
  "Understanding the essay topic...",
  "Key themes and dimensions identified",
  "Building the argument and overall structure...",
  "Logical flow and key arguments prepared",
  "Adding examples, perspectives, and relevant insights...",
  "Supporting points incorporated",
  "Writing the essay...",
  "Refining the essay for UPSC standards...",
];

const LOADING_STEPS_EVALUATE = [
  "Understanding the question and its demand...",
  "Key requirements identified",
  "Analysing your answer...",
  "Arguments, structure, and relevance assessed",
  "Evaluating depth, reasoning, presentation, and examples...",
  "Strengths and gaps identified",
  "Assessing the answer against UPSC standards...",
  "Preparing score and detailed feedback...",
];

const getLoadingSteps = (promptType, currentPretext) => {
  const type = String(currentPretext || "").toLowerCase();
  if (type === "essay" || promptType === "Essay" || promptType === "Frame Your Essay") {
    return LOADING_STEPS_ESSAY;
  }
  if (promptType === "evaluate") {
    return LOADING_STEPS_EVALUATE;
  }
  return LOADING_STEPS_GENERIC;
};

// While a mermaid diagram is still streaming in, wrap its hidden code block
// in a loader placeholder so the user knows a diagram is coming.
const wrapMermaidWithLoader = (html) =>
  String(html || "").replace(
    /(<pre><code(?:\s+class=["'][^"']*language-mermaid[^"']*["'])?[^>]*>[\s\S]*?<\/code><\/pre>)/gi,
    (block) =>
      `<div class="mermaid-loader-wrapper">${block}<div class="mermaid-loader"><span class="mermaid-loader-spinner"></span><span class="mermaid-loader-text">Rendering diagram...</span></div></div>`,
  );

// Restore plain mermaid code blocks once streaming finishes.
const unwrapMermaidLoader = (html) =>
  String(html || "").replace(
    /<div class="mermaid-loader-wrapper">(<pre><code[^>]*language-mermaid[\s\S]*?<\/code><\/pre>)<div class="mermaid-loader">[\s\S]*?<\/div><\/div>/gi,
    (whole, block) => block,
  );

const ChatWindow = ({
  setShowPremiumButton,
  showPremiumButton,
  setIsStreamingDoneSidebar,
  handleSelectMessageItem,
  handleSelectHistoryItem,
  selectedHistory,
  Check,
  isSidebarColl,
  setIsSidebarColl,
  setRefreshHistory,
  interactiveSyllabus,
  setInteractiveSyllabus,
  setHeaderTitle,
}) => {
  const location = useLocation();
  const [convid, setConvid] = useState("");

  const { evalutedata, evaluate } = location.state || {};
  //  console.log("evalutedata",evalutedata);
  //   console.log(evaluate,"evaluate");
  const [popup, setPopup] = useState({ visible: false, x: 0, y: 0, text: "" });
  const [close, setClose] = useState(true);
  const popupRef = useRef(null);
  const [shareUrl, setShareUrl] = useState("");
  const [evaluatequestion, setevaluatequestion] = useState("");
  const [copied, setCopied] = useState(false);
  const [sharePopupPos, setSharePopupPos] = useState({ top: 0, left: 0 });
  const [showSharePopup, setShowSharePopup] = useState(false);
  const [evaluatedetails, setevaluatedetails] = useState({});
  const [attachmark, setAttachmark] = useState("20");
  const [attchsubject, setAttchsubject] = useState("Geography");
  const [fildetail, setFiledetail] = useState(null);
  const [selectedSubject, setSelectedSubject] = useState("");
  const [isMCQVisible, setMCQVisible] = useState(false);
  const [isMainsPracticeVisible, setIsMainsPracticeVisible] = useState(false);
  const [isEvaluateVisible, setEvaluateVisible] = useState(false);
  const [defaultText, setDefaultText] = useState("");
  const [isPrelims, setIsPrelims] = useState(false);
  const [message, setMessage] = useState("");
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [selectedPrompt, setSelectedPrompt] = useState({
    text: "Generic",
    image: "summarise.svg",
  });

  const [showBottom, setShowBottom] = useState(false);
  const divRef = useRef(null);
  const [toptobuttom, settoptobottom] = useState(false);
  const [currentAffairsCode, setCurrentAffairsCode] = useState("");
  const [buttonclicked, setbuttonclicked] = useState("");
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const [isdropdownVisibl, setdropdownVisibl] = useState(false);
  const [prelimquestion, setPrelimQuestion] = useState("");
  const [relatedTopicsData, setRelateTopicsData] = useState(null);
  const [mcqview, setMcqview] = useState(false);
  const [messages, setMessages] = useState([]);
  const [userPrompt, setUserPrompt] = useState("");

  useEffect(() => {
    if (setHeaderTitle) {
      const firstUserMsg = messages.find((msg) => msg.sender === "user");
      setHeaderTitle(firstUserMsg ? firstUserMsg.message : "");
    }
  }, [messages, setHeaderTitle]);
  const [currentPretext, setCurrentPretext] = useState("");
  const [mcqResponse, setMcqResponse] = useState(null);
  const chatInputRef = useRef(null);
  const chatRef = useRef(null);
  const contentRef = useRef();
  const refs = useRef([]);
  const memoriseRef = useRef(null);
  const infographicRef = useRef(null);
  // DOM-only snapshots of rendered Mermaid (do NOT write into messages state)
  const mermaidDomSnapshotRef = useRef({});
  const [responseData, setResponseData] = useState(null);
  const [conversationId, setConversationId] = useState("");
  const [messageId, setMessageId] = useState(null);
  const [messageIdList, setMessageIdList] = useState([]);
  const [topic, setTopic] = useState(null);
  const [keywords, setKeywords] = useState([]);
  const [caseStudies, setCaseStudies] = useState(null);
  const [initiatives, setInitiatives] = useState(null);
  const [isCopied, setIsCopied] = useState(false);
  const [isGeneratedPdf, setIsGeneratedPdf] = useState(false);
  const [isfeedbackform, setfeedbackform] = useState(false);
  const [isMermaidDone, setIsMermaidDone] = useState(false);
  const [isStreamingDone, setIsStreamingDone] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [initialDisplayLimit, setinitialDisplayLimit] = useState(4);
  const [revise, setRevise] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingStep, setLoadingStep] = useState(-1);
  const loadingStepIntervalRef = useRef(null);
  const loadingStepRef = useRef(-1);
  const isFlushedRef = useRef(false);
  const [error, setError] = useState({});
  const [evaluateResponse, setEvaluateResponse] = useState(null);
  const [questionsMap, setQuestionsMap] = useState({});
  const [imageMap, setImageMap] = useState({});
  const [isHistory, setIsHistory] = useState(false);
  const [promptType, setPromptType] = useState();
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [markmapData, setMarkmapData] = useState({});
  // const [relatedTopicData, setRelateTopicData] = useState(null)

  const [isload, setIsLoad] = useState(false);

  const [msgsend, setMsgSend] = useState(true);
  const [sendTrigger, setSendTrigger] = useState(0);
  const [showToolkit, setShowToolkit] = useState(false);
  const [activeToolkitIndex, setActiveToolkitIndex] = useState(null);
  const [toolkitActiveTab, setToolkitActiveTab] = useState("pyq");

  const [shownTopics, setShownTopics] = useState({});

  const [tour, setTour] = useState(localStorage.getItem("hastour"));
  const { profileData } = useContext(AuthContext);
  const trialEndDate = new Date(profileData?.trail_end_at);



  const today = new Date();

  const remainingDays = Math.ceil(
    (trialEndDate - today) / (1000 * 60 * 60 * 24),
  );
  const dropdownRef = useRef(null);
  const [showPromptType, setShowPromptType] = useState(true);

  const [formData, setFormData] = useState({
    easyUse: "",
    challenges: [],
    understand: "yes",
    accuracy: "1",
    improvement: "",
  });

  const [selected, setSelected] = useState("");
  const [showAll, setShowAll] = useState(false);
  const [evalStatus, setEvalStatus] = useState("");
  const [syllabusProgressMap, setSyllabusProgressMap] = useState({});
  const [syllabusProgressLoadingMap, setSyllabusProgressLoadingMap] = useState({});
  const syllabusMsgIndexRef = useRef(null);
  // console.log("evalStatus - ", evalStatus);

  const hasTour = localStorage.getItem("hasTour");
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (popupRef.current && !popupRef.current.contains(e.target)) {
        setShowSharePopup(false);
      }
    };

    if (showSharePopup) {
      // use 'click' so the component's onClick runs before the outside-close check
      document.addEventListener("click", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [showSharePopup]);

  useEffect(() => {
    const applyReferral = async () => {
      const referralCode = localStorage.getItem("referralCode");
      if (referralCode) {
        try {
          await applyReferralCode(referralCode);
          localStorage.removeItem("referralCode");
        } catch (error) {
          console.error("Error applying referral code:", error);
        }
      }
    };
    applyReferral();
  }, []);

  function pickRandom(arr, count) {
    if (!arr || arr.length === 0) return [];
    const a = [...arr];
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a.slice(0, count);
  }

  function preRandomizeSyllabusData(apiData) {
    if (!apiData) return apiData;
    const subjects = pickRandom(apiData.subjects || [], 3).map((s) => ({
      ...s,
      topics: pickRandom(s.topics || [], 3).map((t) => ({
        ...t,
        subtopics: pickRandom(t.subtopics || [], 3),
      })),
    }));
    return { ...apiData, subjects };
  }

  const fetchSyllabusProgressBySubject = useCallback(async (subjectName, index) => {
    if (!subjectName || index === undefined) return;
    const userId = localStorage.getItem("user_id");
    if (!userId) return;
    setSyllabusProgressLoadingMap((prev) => ({ ...prev, [index]: true }));
    try {
      const data = await getSyllabusProgressDetail(subjectName.toLowerCase(), userId);
      setSyllabusProgressMap((prev) => ({ ...prev, [index]: data }));
    } catch {
      setSyllabusProgressMap((prev) => ({ ...prev, [index]: null }));
    } finally {
      setSyllabusProgressLoadingMap((prev) => ({ ...prev, [index]: false }));
    }
  }, []);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      // optional toast / message
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy", err);
    }
  };

  // Limit the number of prompts initially displayed
  // hygjkl

  // useEffect(() => {
  //   if (isStreamingDone) {
  //     setStreamingDoneMap(prev => ({ ...prev, [i]: true }));
  //   }
  // }, [isStreamingDone]);

  const { conversationIdd } = useParams();
  const [clicked, setClicked] = useState(false);

  const { flag } = location.state || {}; // fallback if state is undefined

  const { initialMessages } = location.state || {};
  const [isScrolling, setIsScrolling] = useState(false);
  const [messageCount, setMessageCount] = useState(0);

  useEffect(() => {
    const checkTouch = () => {
      const divRect = divRef.current?.getBoundingClientRect();
      const chatRect = chatRef.current?.getBoundingClientRect();
      if (!divRect || !chatRect) return;

      // Check if the bottom of divRef touches or crosses the top of chatRef
      if (divRect.bottom >= chatRect.top - 20) {
        setShowBottom(true);
      }
    };

    // Run once and on scroll/resize
    checkTouch();
    window.addEventListener("scroll", checkTouch);
    window.addEventListener("resize", checkTouch);

    return () => {
      window.removeEventListener("scroll", checkTouch);
      window.removeEventListener("resize", checkTouch);
    };
  });

  const handlePromptSelect = (prompt, imageName) => {
    setdropdownVisibl(false);
    if (isPrelims) {
      setMessage("");
      setIsPrelims(false);
    }

    setSelectedPrompt({ text: prompt, image: imageName });
    setDropdownVisible(false);
    if (prompt === "Prelims Practice") {
      setMCQVisible(true);
      setIsMainsPracticeVisible(false);
      setEvaluateVisible(false);
      setDefaultText("");
      setIsPrelims(true);
      setMessage(`Give me MCQ questions for ${selectedSubject} `);
    } else if (prompt === "Main Practice" || prompt === "Mains Practice") {
      setMCQVisible(false);
      setIsMainsPracticeVisible(true);
      setEvaluateVisible(false);
      setDefaultText("");
      setIsPrelims(true);
      setMessage(`Give me PYQs for ${selectedSubject} `);
    }
  };
  // useEffect(() => {
  //   const checkTouch = () => {
  //     const div = divRef.current;
  //     const chat = chatRef.current;
  //     if (!div || !chat) return;

  //     // Calculate if the scroll is at the bottom (or near bottom, e.g., 20px threshold)
  //     const isAtBottom = div.scrollHeight - div.scrollTop - div.clientHeight <= 20;
  //     if (isAtBottom) {
  //       console.log('divRef content bottom touched chatRef');
  //     }
  //     else {
  //       console.log('divRef content not touching chatRef');
  //     }
  //   };

  //   // Listen to scroll on divRef, not window
  //   const div = divRef.current;
  //   if (div) {
  //     div.addEventListener('scroll', checkTouch);
  //   }
  //   window.addEventListener('resize', checkTouch);

  //   // Initial check
  //   checkTouch();

  //   return () => {
  //     if (div) {
  //       div.removeEventListener('scroll', checkTouch);
  //     }
  //     window.removeEventListener('resize', checkTouch);
  //   };
  // });

  // useEffect(() => {
  //   if (messages[0]?.message === "") {
  //     setMessages(prevMessages => prevMessages?.slice(1));
  //   }
  // }, [messages]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolling(true);
      setShowSharePopup(false);
      setPopup({ visible: false, x: 0, y: 0, text: "" });
      // console.log("scrooling")
    };

    const div = divRef.current;
    if (div) {
      div.addEventListener("wheel", handleScroll);
    }

    // Cleanup
    return () => {
      if (div) {
        div.removeEventListener("wheel", handleScroll);
      }
    };
  });

  // Track message count to detect new messages
  useEffect(() => {
    if (messages.length > messageCount) {
      // New message added - reset scroll state to allow auto-scroll
      setIsScrolling(false);
      setMessageCount(messages.length);
    }
  }, [messages.length, messageCount]);

  useEffect(() => {
    if (messageId != null) setMessageIdList((prev) => [...prev, messageId]);
  }, [messageId]);

  // useEffect(() => {
  //   const url = location.pathname;
  //   const parts = url.split("/");
  //   const id = parts[parts.length - 1];

  //   const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  //   setConversationId(uuidPattern.test(id) ? id : null);
  // }, [location])

  useEffect(() => {
    setMessages([]);
    setMessageIdList([]);
    setMsgSend(true);
    setShowPromptType(false);
    setIsHistory(false);
    setConversationId("");
    setMessageId(null);
    setImageMap({});
    setQuestionsMap({});
    setRelatedTopicsMap({});
    setRelatedSummariesMap({});
    setSyllabusProgressMap({});
    setSyllabusProgressLoadingMap({});
    setTopic(null);
    setShowToolkit(false);
    setActiveToolkitIndex(null);
  }, [flag]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setdropdownVisibl(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setinitialDisplayLimit(4);
      } else {
        setinitialDisplayLimit(4);
      }
      setIsMobile(window.innerWidth <= 768); // Define your mobile breakpoint
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Handler to toggle show all prompts
  const handleToggleShowAll = () => {
    setShowAll((prevShowAll) => !prevShowAll);
  };

  useEffect(() => {
    if (selectedHistory && !flag) {
      setMessages([]);
      setIsStreamingDone(false);
      setIsStreamingDoneSidebar(false);
      extractMessageFromHistory(selectedHistory);
      setIsHistory(true);
    }
  }, [selectedHistory]);

  useEffect(() => {
    const path = location.pathname;
    const pathSegments = path.split("/");
    if (conversationIdd) {
      if (pathSegments.includes("message")) {
        //  console.log("conversationIdd",conversationIdd)
        setMessageIdList((prev) => [...prev, conversationIdd]);
        handleSelectMessageItem(conversationIdd);
      } else {
        handleSelectHistoryItem(conversationIdd);
      }
    }
  }, []);
  const extractMessageFromHistory = (history) => {
    const allMessages = [];
    const mapping = {
      essay: "Frame Your Essay",
      short_note: "Quick Topic Summary",
      case_study: "Explore a Case Study",
      generic: "Generic",
      answer: "See a Model Answer",
      approach: "Plan Your Answer",
      evaluate: "evaluate",
    };

    // Clear enrichment maps so previous chat data does not bleed into history
    setRelatedTopicsMap({});
    setRelatedTopicsLoadingMap({});
    setRelatedSummariesMap({});
    setRelatedSummariesLoadingMap({});
    setQuestionsMap({});
    setMarkmapData({});
    setImageMap({});
    setSyllabusProgressMap({});
    setSyllabusProgressLoadingMap({});

    const normalizeHistoryKeywords = (message, rawMessage = "") => {
      const raw =
        message.keywordsArray ??
        message.keywords ??
        null;

      let list = [];
      if (Array.isArray(raw)) {
        list = raw;
      } else if (typeof raw === "string" && raw.trim()) {
        if (raw.includes("<")) {
          list = extractKeywordsFromHtml(raw);
        } else {
          list = raw.split(",").map((k) => k.trim()).filter(Boolean);
        }
      }

      if (!list.length && message.keywordsHtml) {
        list = extractKeywordsFromHtml(message.keywordsHtml);
      }
      if (!list.length && rawMessage) {
        list = extractKeywordsFromHtml(rawMessage);
      }

      return list.map(cleanKeywordLabel).filter(Boolean);
    };

    for (const [index, message] of history.messages.entries()) {
      const prompt = mapping[message.template] || "Generic";
      const messageId = message.messageId;
      const fullResponse = message.message;
      const historySubject =
        extractSubjectFromTheme(message.theme) || null;

      setIsStreamingDone(false);
      setIsStreamingDoneSidebar(false);
      if (message.sender === "user") {
        const newMessage = {
          sender: "user",
          message: message.message,
          prompt,
          subject: historySubject,
          mcqData: null,
          topic: null,
          keywords: null,
          caseStudies: null,
          initiatives: null,
        };
        setUserPrompt(message.message);
        setCurrentAffairsCode("");
        setCurrentPretext(mapping[message.template] || "Generic");
        setMessages((prev) => [...prev, newMessage]);
        allMessages.push(newMessage);
      } else {
        const prepared = prepareMentorMindResponse(fullResponse);
        const keywordsArray = normalizeHistoryKeywords(message, fullResponse);
        setKeywords(keywordsArray);

        // Prefer stored enrichments; split by section headings when CS/Initiatives are mixed
        const storedCaseStudies =
          message.case_study || message.caseStudies || null;
        const storedInitiatives =
          message.initiative || message.initiatives || null;

        const fromNote = extractEnrichmentSections(fullResponse);
        const fromStoredCase = storedCaseStudies
          ? extractEnrichmentSections(storedCaseStudies)
          : { caseStudies: "", initiatives: "" };
        const fromStoredInitiative = storedInitiatives
          ? extractEnrichmentSections(storedInitiatives)
          : { caseStudies: "", initiatives: "" };

        // If stored blobs include headings, use heading-scoped cards so tabs stay separate
        const headingScopedCase =
          fromStoredCase.caseStudies || fromNote.caseStudies || "";
        const headingScopedInitiative =
          fromStoredInitiative.initiatives ||
          fromStoredCase.initiatives ||
          fromNote.initiatives ||
          "";

        let caseStudiesHtml = headingScopedCase || null;
        let initiativesHtml = headingScopedInitiative || null;

        // Typed/stored payloads that are already card-only (no headings)
        if (!caseStudiesHtml && storedCaseStudies && !fromStoredCase.initiatives) {
          caseStudiesHtml =
            normalizeCards(storedCaseStudies) || storedCaseStudies || null;
        }
        if (
          !initiativesHtml &&
          storedInitiatives &&
          !fromStoredInitiative.caseStudies
        ) {
          initiativesHtml =
            normalizeCards(storedInitiatives) || storedInitiatives || null;
        }

        if (prepared.markmap) {
          setMarkmapData((prev) => ({
            ...prev,
            [index]: prepared.markmap,
          }));
        }
        setTopic(prepared.topic);

        if (message.current_affairs?.matches || message.current_affairs) {
          const matches = message.current_affairs?.matches || message.current_affairs;
          if (Array.isArray(matches)) {
            setRelatedTopicsMap((prev) => ({ ...prev, [index]: matches }));
            setRelatedTopicsLoadingMap((prev) => ({ ...prev, [index]: false }));
          }
        }

        const historyPyq = message.pyq || "";
        const historyRevise = message.revise || "";

        const newMessage = {
          sender: "bot",
          message: prepared.html,
          prompt: prompt,
          subject: historySubject,
          mcqData: null,
          topic: prepared.topic,
          keywords: message.keywordsHtml
            ? normalizeKeywordsHtml(message.keywordsHtml)
            : keywordsArray.length
              ? keywordsArray
                .map((keyword) => `<p class="keyword">${keyword}</p>`)
                .join("")
              : null,
          caseStudies: caseStudiesHtml,
          initiatives: initiativesHtml,
          keywordsArray: keywordsArray,
          hasStatusMatch: false,
          isFeedbackFormSubmitted: false,
          messageId: messageId,
          pyq: historyPyq,
          // Non-empty revise unlocks Exam Toolkit button; keep preparing state only while refetching
          revise: historyRevise || (historyPyq ? " " : ""),
        };
        setMessages((prev) => [...prev, newMessage]);
        allMessages.push(newMessage);

        // Fetch syllabus progress if subject is available
        if (historySubject) {
          fetchSyllabusProgressBySubject(historySubject, index);
        }

        setIsStreamingDone(true);
        setIsStreamingDoneSidebar(true);
        if (fullResponse && prompt != "Frame Your Essay") {
          const prevUserMessage = allMessages[index - 1]?.message;
          if (keywordsArray.length > 0) {
            fetchQuestions(
              "",
              index,
              keywordsArray,
              message.theme,
              prevUserMessage,
            );
            // Prefer stored CA; otherwise refetch from keywords
            if (!(message.current_affairs?.matches || Array.isArray(message.current_affairs))) {
              fetchRelatedTopics("", index, keywordsArray);
            }
          }
          if (prevUserMessage) {
            // Always fetch the Current Affairs Summary in history (consolidated_summary),
            // falling back to the user's question as keywords so the summary card shows.
            const summaryKeywords =
              keywordsArray.length > 0 ? keywordsArray : [prevUserMessage];
            if (summaryKeywords.length > 0) {
              fetchRelatedSummaries(index, summaryKeywords);
            }
            fetchImages(index, prevUserMessage);
          }
        }

        // Restore Exam Toolkit if history did not persist pyq/revise
        const prevUserMessage = allMessages[index - 1]?.message;
        if (
          keywordsArray.length > 0 &&
          messageId &&
          messageId !== "8b75626b-2324-4ef8-903b-fc3fe12fbb96" &&
          (!historyPyq || !historyRevise) &&
          prevUserMessage &&
          prompt !== "Frame Your Essay"
        ) {
          revisePyq(prevUserMessage, messageId)
            .then((response) => {
              setMessages((prev) =>
                prev.map((msg, i) =>
                  i === index
                    ? {
                      ...msg,
                      pyq: response?.pyq || msg.pyq || "",
                      revise: response?.revise || msg.revise || " ",
                    }
                    : msg,
                ),
              );
            })
            .catch((error) => {
              console.error("Error restoring PYQ/Revise from history:", error);
              setMessages((prev) =>
                prev.map((msg, i) =>
                  i === index && !msg.revise
                    ? { ...msg, revise: " " }
                    : msg,
                ),
              );
            });
        }

        // Also fetch images if there's markmap content (infographic)
        if (prepared.markmap && allMessages[index - 1]?.message) {
          fetchImages(index, allMessages[index - 1].message);
        }

        setUserPrompt("");
        setCurrentAffairsCode("");
        setIsLoading(false);
        setRefreshHistory();
        validateAccessToken();
      }
    }
    setConversationId(history.id);
    setShowPromptType(true);
  };

  useEffect(() => {
    // Load MCQ response data from the JSON file
    const fetchMCQResponse = async () => {
      try {
        const response = await fetch("/data/mcqResponse.json"); // Adjust the path as needed
        if (!response.ok) throw new Error("Failed to load MCQ response");
        const data = await response.json();
        setMcqResponse(data);
      } catch (error) {
        console.error("Error fetching MCQ response:", error);
      }
    };

    fetchMCQResponse();
  }, []);

  useEffect(() => {
    const fetchEvaluateResponse = async () => {
      try {
        const response = await fetch("/data/evaluate.json"); // Adjust the path as needed
        if (!response.ok) throw new Error("Failed to load MCQ response");
        const data = await response.json();
        setEvaluateResponse(data);
      } catch (error) {
        console.error("Error fetching MCQ response:", error);
      }
    };

    fetchEvaluateResponse();
  }, []);

  useEffect(() => {
    if (
      userPrompt &&
      promptType !== "Prelims Practice" &&
      promptType !== "evaluate"
    ) {
      setKeywords([]);
      fetchImages(messages.length, topic);
      callMentorMindApi();
    }
  }, [sendTrigger]);

  useEffect(() => {
    if (isStreamingDone) {
      refs.current.forEach((ref) => {
        if (ref?.current) {
          processMermaidDiagrams(ref.current);
        }
      });
    }
  }, [isStreamingDone, messages]);

  useEffect(() => {
    if (typeof mermaid !== "undefined" && isMermaidDone) {
      mermaid
        .run()
        .then(() => { })
        .catch(() => { });
      setIsMermaidDone(false);

      setIsStreamingDone(true);
      setIsStreamingDoneSidebar(true);
    }
  }, [isMermaidDone]);

  const fetchQuestions = async (
    fullResponse,
    index,
    keywordsArray = [],
    theme = "",
    userPrompt = "",
  ) => {
    const keywordRegex = /<p _className_="keyword">(.*?)<\/p>/g;
    const keywords = keywordsArray.length > 0 ? keywordsArray : [];
    let keywordMatch;
    while ((keywordMatch = keywordRegex.exec(fullResponse)) !== null) {
      const keywordContent = keywordMatch[1].trim();
      if (keywordContent) {
        // Clean the keyword text - remove any HTML tags and extra spaces
        const cleanKeyword = keywordContent
          .replace(/<[^>]*>/g, "") // Remove any HTML tags
          .replace(/\s+/g, " ") // Replace multiple spaces with single space
          .trim();
        if (cleanKeyword) {
          keywords.push(cleanKeyword);
        }
      }
    }
    setLoading(true);

    try {
      // Optionally indicate loading state
      const suggestedQuestions = await getSuggestedQuestions(
        keywords,
        theme,
        userPrompt,
      );
      const suggestedQuestionsData = [];
      suggestedQuestions.matches.map((item) => {
        suggestedQuestionsData.push({
          id: item.q_id,
          question: item.qstn,
          subject: item.subject,
          topic: item.topic,
          subtopic: item.subtopic,
          year: item.year,
          type: "pyq",
          ans_identifier: null,
        });
      });

      setQuestionsMap((prevMap) => ({
        ...prevMap,
        [index]: {
          message: keywords,
          suggestedQuestions: suggestedQuestionsData,
        }, // Store questions for the specific bot response
      }));
    } catch (err) {
      setError((prevMap) => ({
        ...prevMap,
        [index]: { error: err.message }, // Store questions for the specific bot response
      }));
      // setError(err.message);
    } finally {
      setLoading(false); // Reset loading state
    }
  };


  const fetchImages = async (index, topicData = null) => {
    setLoading(true);
    const query = topicData || userPrompt;
    if (!query) {
      setLoading(false);
      return;
    }
    try {
      const responseTopic = await findNewImages(
        query,
        profileData.user_type,
      );
      setImageMap((prevMap) => ({
        ...prevMap,
        [index]: responseTopic.results,
      }));
    } catch (err) {
      // setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const navigate = useNavigate();
  useEffect(() => {
    if (
      conversationId !== "" &&
      (window.location.pathname.endsWith("/chat") ||
        window.location.pathname.includes("/message"))
    ) {
      const basePath = window.location.pathname.replace(/\/message\/[^/]+/, "");

      const newUrl = `${basePath}/${conversationId}`;
      window.history.pushState({}, "", newUrl);
    } else if (
      conversationId != "" &&
      !window.location.pathname.endsWith("/chat")
    ) {
      const conversationIdFromUrl = window.location.pathname.split("/").pop();
      if (conversationIdFromUrl !== conversationId) {
        const pathname = window.location.pathname;
        const basePath =
          pathname === "/chat" || !pathname.includes("/chat")
            ? "/chat"
            : pathname.split("/").slice(0, -1).join("/");
        const newUrl = `${basePath}/${conversationId}`;
        window.history.pushState({}, "", newUrl);
      }
    }
  }, [conversationId]);

  useEffect(() => {
    if (conversationId && conversationId !== "" && isStreamingDone) {
      // navigate(`/Chatwindow/${conversationId}`, { replace: true });
    }
  }, [isStreamingDone]);

  useEffect(() => {
    return () => {
      if (loadingStepIntervalRef.current) {
        clearInterval(loadingStepIntervalRef.current);
        loadingStepIntervalRef.current = null;
      }
    };
  }, []);

  const handleToolkitOpen = (index) => {
    // Same UX: chat unmounts, toolkit shows.
    // Keep Mermaid visuals in a DOM snapshot ref (never mutate message HTML).
    mermaidDomSnapshotRef.current = {};
    refs.current.forEach((ref, i) => {
      const el = ref?.current;
      if (!el) return;
      if (
        el.querySelector(
          ".mermaid svg, svg[id^='mermaid'], svg[aria-roledescription='flowchart'], svg[aria-roledescription='sequence']",
        )
      ) {
        mermaidDomSnapshotRef.current[i] = el.innerHTML;
      }
    });
    setShowToolkit(true);
    setActiveToolkitIndex(index);
  };
  const handleDownloadMindmap = () => {
    if (infographicRef.current?.expandAll) {
      infographicRef.current.expandAll();
    }
    setTimeout(() => {
      if (memoriseRef.current) {
        html2canvas(memoriseRef.current, {
          scale: 2,
          useCORS: true,
          backgroundColor: "#ffffff",
          onclone: (clonedDoc) => {
            const clonedEl = clonedDoc.querySelector('[data-memorise-content]');
            if (clonedEl) {
              clonedEl.style.wordBreak = "normal";
              clonedEl.style.overflowWrap = "normal";
              clonedEl.style.whiteSpace = "normal";
            }
          },
        }).then((canvas) => {
          const link = document.createElement("a");
          link.download = "mindmap.png";
          link.href = canvas.toDataURL("image/png");
          link.click();
        });
      }
    }, 500);
  };
  const handleToolkitClose = () => {
    const scrollToIndex = activeToolkitIndex;
    setShowToolkit(false);
    setActiveToolkitIndex(null);
    setTimeout(() => {
      // Restore Mermaid from snapshot, or re-render from code fences.
      refs.current.forEach((ref, i) => {
        if (!ref?.current) return;
        const snap = mermaidDomSnapshotRef.current[i];
        if (snap) {
          ref.current.innerHTML = snap;
        } else {
          processMermaidDiagrams(ref.current);
        }
      });
      const msgEl = document.querySelector(`.message-row-${scrollToIndex}`);
      if (msgEl) {
        msgEl.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, 100);
  };

  const handleSend = ({ message, prompt, mcqData, mainsPractice }) => {
    setShowPremiumButton(false);
    setIsScrolling(false);
    if (!message) return;
    setPromptType(prompt);
    setIsHistory(false);
    // setConversationId("");
    const mapping = {
      Essay: "essay",
      "Frame Your Essay": "essay",
      "See a Model Answer": "answer",
      Answer: "answer",
      "Plan Your Answer": "approach",
      "Explore a Case Study": "case_study",
      "Quick Topic Summary": "short_note",
      Generic: "",
    };

    const handleSendMessage = async () => {
      if (prompt === "evaluate") {
        setIsLoading(true);
        setLoadingStep(0);
        if (loadingStepIntervalRef.current) {
          clearInterval(loadingStepIntervalRef.current);
        }
        loadingStepIntervalRef.current = setInterval(() => {
          setLoadingStep((prev) => {
            const next = prev < LOADING_STEPS_EVALUATE.length - 1 ? prev + 1 : LOADING_STEPS_EVALUATE.length - 1;
            loadingStepRef.current = next;
            return next;
          });
        }, 2000);
        try {
          const res = await uploadPdfService(
            fildetail,
            message,
            prompt,
            attachmark,
            attchsubject == "GS" ? "General Studies" : attchsubject,
            conversationId,
          );
          setevaluatequestion(message);
          setEvalStatus(res.data.status);
          setSelectedPrompt({ text: "evaluate" });
          if (res.data.status == "rate_limited") {
            setShowPremiumButton(true);
          }

          if (conversationId == "") {
          }
          setConversationId(res.data.conversation_id);

          const botmesasage = {
            sender: "bot",
            message: res.data.evaluation,
            prompt: "evaluate",
            messageId: res.data.message_id,
            evalStatus: res.data.status,
            mcqData: null,
            topic: null,
            keywords: null,
            caseStudies: null,
            initiatives: null,
          };

          setMessages((prevMessages) => [...prevMessages, botmesasage]);
        } catch (error) {
          console.error("Upload error:", error);
        } finally {
          setIsLoading(false);
          if (loadingStepIntervalRef.current) {
            clearInterval(loadingStepIntervalRef.current);
            loadingStepIntervalRef.current = null;
          }
          setLoadingStep(-1);
          setSelectedPrompt({ text: "Generic", image: "summarise.svg" });
          setEvaluateVisible(false);
        }
      }
    };

    // Create a new message with null components
    const newMessage = {
      sender: "user",
      message,
      prompt,
      mcqData,
      topic: null,
      keywords: null,
      caseStudies: null,
      initiatives: null,
      isFeedbackFormSubmitted: false,
      attchsubject: attchsubject,
    };

    if (prompt === "model") {
      const lastUserMsg = messages[messages.length - 2].message;
      setMessages((prev) => [
        ...prev,
        { ...newMessage, message: lastUserMsg, prompt: "answer" },
      ]);
      setUserPrompt(lastUserMsg);
      setSendTrigger((prev) => prev + 1);
      setCurrentAffairsCode("");
      setCurrentPretext("answer");
      setQuestions("");
    } else {
      setMessages((prev) => [...prev, newMessage]);

      if (prompt === "Prelims Practice" || prompt === "Mcq") {
        setTimeout(() => {
          setMessages((prev) => [
            ...prev,
            {
              sender: "bot",
              message: "",
              prompt: prompt,
              mcqData,
              topic: null,
              keywords: null,
              caseStudies: null,
              initiatives: null,
              isFeedbackFormSubmitted: false,
              revise: "",
              pyq: "",
            },
          ]);
        }, 1000);
      } else if (prompt === "evaluate") {
        // console.log(fildetail,"inside evaluate")
        handleSendMessage();
      } else if (prompt == "Mains Practice" || prompt == "Main Practice") {
        setTimeout(() => {
          setMessages((prev) => [
            ...prev,
            {
              sender: "bot",
              message: "",
              prompt: prompt,
              mainsPractice,
              mcqData,
              topic: null,
              keywords: null,
              caseStudies: null,
              initiatives: null,
              isFeedbackFormSubmitted: false,
              revise: "",
              pyq: "",
            },
          ]);
        }, 1000);
      } else {
        setUserPrompt(message);
        setSendTrigger((prev) => prev + 1);
        setCurrentAffairsCode("");
        setCurrentPretext(mapping[prompt]);
      }
    }
  };
  const { isAuthenticated, keycloak } = useContext(AuthContext);
  const validateAccessToken = async () => {
    // Use Keycloak's built-in authentication check
    if (!isAuthenticated) {
      try {
        keycloak.login();
      } catch (error) {
        console.error(
          "Error during login:",
          error.response ? error.response.data : error.message,
        );
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        window.location.reload();
      }
    }
  };

  const handlePromptSelectChatwindow = (promptType) => {
    if (chatInputRef.current) {
      chatInputRef.current.handleSelectPrompt(promptType, "");
    }
  };

  const [currentMessageIndex, setCurrentMessageIndex] = useState(null);

  const getfeedbackform = (index) => {
    setCurrentMessageIndex(index);
    setfeedbackform(true);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prevData) => {
        const updatedChallenges = checked
          ? [...prevData.challenges, value]
          : prevData.challenges.filter((item) => item !== value);
        return { ...prevData, challenges: updatedChallenges };
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoad(true);
    submitFeedback(
      messageId,
      conversationId,
      formData.easyUse,
      formData.understand,
      formData.accuracy,
      formData.improvement,
    )
      .then((response) => {
        // Update feedback status in the message object itself using the stored index
        setMessages((prevMessages) => {
          const updatedMessages = [...prevMessages];
          if (
            currentMessageIndex !== null &&
            updatedMessages[currentMessageIndex]
          ) {
            updatedMessages[currentMessageIndex] = {
              ...updatedMessages[currentMessageIndex],
              isFeedbackFormSubmitted: true,
            };
          }
          return updatedMessages;
        });

        // Hide feedback message after 2 seconds
        setTimeout(() => {
          setMessages((prevMessages) => {
            const updatedMessages = [...prevMessages];
            if (
              currentMessageIndex !== null &&
              updatedMessages[currentMessageIndex]
            ) {
              updatedMessages[currentMessageIndex] = {
                ...updatedMessages[currentMessageIndex],
                isFeedbackFormSubmitted: false,
              };
            }
            return updatedMessages;
          });
        }, 2000);
      })
      .catch((e) => {
      })
      .finally(() => {
        setfeedbackform(false);
        setIsLoad(false);
        setCurrentMessageIndex(null);
      });
  };

  const [relatedTopicsMap, setRelatedTopicsMap] = useState({});
  const [relatedTopicsLoadingMap, setRelatedTopicsLoadingMap] = useState({});
  const [relatedSummariesMap, setRelatedSummariesMap] = useState({});
  const [relatedSummariesLoadingMap, setRelatedSummariesLoadingMap] = useState({});

  const callMentorMindApi = async () => {
    isFlushedRef.current = false;
    loadingStepRef.current = -1;
    const activeLoadingSteps = getLoadingSteps(promptType, currentPretext);
    setIsLoading(true);
    setLoadingStep(0);
    if (loadingStepIntervalRef.current) {
      clearInterval(loadingStepIntervalRef.current);
    }
    loadingStepIntervalRef.current = setInterval(() => {
      setLoadingStep((prev) => {
        const next = prev < activeLoadingSteps.length - 1 ? prev + 1 : activeLoadingSteps.length - 1;
        loadingStepRef.current = next;
        return next;
      });
    }, 2000);
    setResponseData("");
    setQuestions("");
    setTopic("");
    setIsStreamingDone(false);
    setIsStreamingDoneSidebar(false);
    const user_id = localStorage.getItem("user_id");
    const requestBody = {
      conversation_id: conversationId,
      context: currentAffairsCode,
      user_id: user_id,
      // model: "gpt-5.6-luna",
      system_message: "You are a helpful UPSC assistant",
      prompt: userPrompt,
      stream: true,
      response_format: "text",
      answer_type: currentPretext ? currentPretext : "generic",
      messageId: messageId,
    };

    let hasFetchedKeywordData = false; // ensure we only invoke related APIs once per response
    let hasTriggeredRevisePyq = false; // ensure we only invoke revisePyq once per response
    let currentTheme = ""; // theme of this response, sent along with PYQ search

    try {
      const reader = await invokeChainAPI(requestBody);
      const decoder = new TextDecoder("utf-8");
      let fullResponse = "";
      let done = false;
      let hasStatus = false;
      let keywordsContainer = [];
      // let currentMessageId = null;

      setMessages((prev) => {
        const newMsgs = [...prev, {
          sender: "bot",
          message: "",
          prompt: promptType,
          subject: null,
          topic: null,
          keywords: null,
          caseStudies: null,
          initiatives: null,
          hasStatusMatch: false,
          isFeedbackFormSubmitted: false,
          revise: "",
          pyq: "",
          hasFetched: false,
        }];
        syllabusMsgIndexRef.current = newMsgs.length - 1;
        return newMsgs;
      });
      let buffer = "";
      while (!done) {
        const { value, done: streamDone } = await reader.read();
        if (isLoading) {
          setLoading(false);
          setIsLoading(false);
        }
        done = streamDone;
        const chunk = decoder.decode(value, { stream: true });
        // const lines = chunk.split("\n");
        buffer += chunk;
        const lines = buffer.split("\n");
        buffer = lines.pop(); // Keep the last partial line in the buffer

        for (const line of lines) {
          if (line.startsWith("data: ")) {
            try {
              const data = JSON.parse(line.slice(6));

              if (typeof data.theme === "string" && data.theme.trim()) {
                currentTheme = data.theme;
              }

              if (data.message && promptType != "Prelims Practice") {
                // currentMessageId = data.message;
                setMessageId(data.message);
                // console.log("currentMessageId",currentMessageId)
                setMessages((prevItems) => {
                  const updatedItems = [...prevItems];
                  const lastIndex = updatedItems.length - 1;
                  if (lastIndex < 0 || !updatedItems[lastIndex]) return prevItems;
                  updatedItems[lastIndex] = {
                    ...updatedItems[lastIndex],
                    messageId: data.message,
                  };
                  return updatedItems;
                });
                // Fire revisePyq immediately with the message id from the first SSE line,
                // without waiting for the mentor mind stream to finish.
                // Skip if the first line has an empty theme, or the answer type is essay.
                const isEssayAnswerType =
                  currentPretext === "essay" ||
                  promptType === "Frame Your Essay" ||
                  promptType === "Essay";
                if (
                  !hasTriggeredRevisePyq &&
                  userPrompt &&
                  data.theme &&
                  !isEssayAnswerType
                ) {
                  hasTriggeredRevisePyq = true;
                  const currentMsgId = data.message;
                  revisePyq(userPrompt, currentMsgId)
                    .then((response) => {
                      setMessages((prevItems) => {
                        const updatedItems = [...prevItems];
                        const lastIndex = updatedItems.length - 1;
                        if (
                          lastIndex < 0 ||
                          !updatedItems[lastIndex] ||
                          !updatedItems[lastIndex].messageId ||
                          updatedItems[lastIndex].messageId !== currentMsgId
                        )
                          return prevItems;
                        updatedItems[lastIndex] = {
                          ...updatedItems[lastIndex],
                          pyq:
                            response?.pyq || updatedItems[lastIndex].pyq || "",
                          revise:
                            response?.revise ||
                            updatedItems[lastIndex].revise ||
                            " ",
                        };
                        return updatedItems;
                      });
                    })
                    .catch((error) => {
                      console.error("Error fetching PYQ/Revise:", error);
                      setMessages((prevItems) => {
                        const updatedItems = [...prevItems];
                        const lastIndex = updatedItems.length - 1;
                        if (
                          lastIndex < 0 ||
                          !updatedItems[lastIndex].messageId ||
                          updatedItems[lastIndex].messageId !== currentMsgId
                        )
                          return prevItems;
                        if (!updatedItems[lastIndex].revise) {
                          updatedItems[lastIndex] = {
                            ...updatedItems[lastIndex],
                            revise: " ",
                          };
                        }
                        return updatedItems;
                      });
                    });
                }
              }

              if (data.theme && promptType != "Prelims Practice") {
                const subject = extractSubjectFromTheme(data.theme);
                if (subject) {
                  const msgIndex = syllabusMsgIndexRef.current;
                  setMessages((prevItems) => {
                    const updatedItems = [...prevItems];
                    const lastIndex = updatedItems.length - 1;
                    if (lastIndex < 0 || !updatedItems[lastIndex]) return prevItems;
                    updatedItems[lastIndex] = {
                      ...updatedItems[lastIndex],
                      subject,
                    };
                    return updatedItems;
                  });
                  if (msgIndex !== null) {
                    fetchSyllabusProgressBySubject(subject, msgIndex);
                  }
                }
              }

              // Keywords arrive only as typed SSE events
              if (data.type === "keywords") {
                const backendKeywords = (
                  data.keywords && data.keywords.length > 0
                    ? data.keywords
                    : extractKeywordsFromHtml(data.response)
                )
                  .map(cleanKeywordLabel)
                  .filter(Boolean);
                const keywordsHtml = backendKeywords.length
                  ? backendKeywords
                    .map((keyword) => `<p class="keyword">${keyword}</p>`)
                    .join("")
                  : normalizeKeywordsHtml(data.response);

                if (backendKeywords.length > 0 || keywordsHtml) {
                  setMessages((prevItems) => {
                    const updatedItems = [...prevItems];
                    const lastIndex = updatedItems.length - 1;
                    if (lastIndex < 0 || !updatedItems[lastIndex]) return prevItems;
                    const wasFetched = Boolean(updatedItems[lastIndex].hasFetched);

                    updatedItems[lastIndex] = {
                      ...updatedItems[lastIndex],
                      keywordsArray: backendKeywords.length
                        ? backendKeywords
                        : updatedItems[lastIndex].keywordsArray,
                      keywords:
                        keywordsHtml || updatedItems[lastIndex].keywords,
                      hasStatusMatch: false,
                      hasFetched:
                        wasFetched ||
                        (backendKeywords.length > 0 ? true : false),
                    };

                    if (
                      backendKeywords.length > 0 &&
                      !wasFetched &&
                      !hasFetchedKeywordData
                    ) {
                      const fetchIndex = lastIndex;
                      fetchQuestions(
                        "",
                        fetchIndex,
                        backendKeywords,
                        data.theme || currentTheme,
                        requestBody.prompt,
                      );
                      // CA comes via type: current_affairs
                      fetchRelatedSummaries(fetchIndex, backendKeywords);
                      hasFetchedKeywordData = true;
                    }
                    return updatedItems;
                  });
                  if (backendKeywords.length > 0) {
                    keywordsContainer.push(...backendKeywords);
                    setKeywords(backendKeywords);
                  }
                }
                continue;
              }

              // Handle PYQ/Revise events
              if (data.type === "pyq_revise_start") {
                // PYQ/Revise now comes from the revisePyq API, not the SSE stream
                continue;
              }
              if (data.type === "case_study") {
                if (data.response) {
                  const cards = normalizeCards(data.response);
                  setMessages((prevItems) => {
                    const updatedItems = [...prevItems];
                    const lastIndex = updatedItems.length - 1;
                    if (lastIndex < 0 || !updatedItems[lastIndex]) return prevItems;
                    updatedItems[lastIndex] = {
                      ...updatedItems[lastIndex],
                      caseStudies: cards || updatedItems[lastIndex].caseStudies,
                    };
                    return updatedItems;
                  });
                }
                continue;
              }
              if (data.type === "initiative") {
                if (data.response) {
                  const cards = normalizeCards(data.response);
                  setMessages((prevItems) => {
                    const updatedItems = [...prevItems];
                    const lastIndex = updatedItems.length - 1;
                    if (lastIndex < 0 || !updatedItems[lastIndex]) return prevItems;
                    updatedItems[lastIndex] = {
                      ...updatedItems[lastIndex],
                      initiatives: cards || updatedItems[lastIndex].initiatives,
                    };
                    return updatedItems;
                  });
                }
                continue;
              }
              if (data.type === "current_affairs") {
                const msgIndex = syllabusMsgIndexRef.current;
                if (msgIndex !== null) {
                  setRelatedTopicsMap((prev) => ({
                    ...prev,
                    [msgIndex]: data.matches || [],
                  }));
                  setRelatedTopicsLoadingMap((prev) => ({
                    ...prev,
                    [msgIndex]: false,
                  }));
                }
                continue;
              }
              if (
                data.type === "enrichment_error" ||
                data.type === "enrichments_complete"
              ) {
                // Non-fatal; do not clear main answer
                continue;
              }
              // Unknown typed events must not abort the stream on empty response
              if (data.type && data.response == "" && !data.error) {
                continue;
              }

              if (data.response == "") {
                setError((prevMap) => ({
                  ...prevMap,
                  [messages.length - 1]: {
                    error: data.error
                      ? "Your message contains content that violates our content policy. Please rephrase your message and try again."
                      : undefined,
                  },
                }));
                // Keep reading for typed enrichments
                if (data.message || !data.error) {
                  continue;
                }
                break;
              } else {
                if (data.response && promptType != "Prelims Practice") {
                  // Never append typed enrichment / side-channel payloads into the note body
                  if (
                    data.type === "case_study" ||
                    data.type === "initiative" ||
                    data.type === "keywords" ||
                    data.type === "current_affairs" ||
                    data.type === "enrichment_error" ||
                    data.type === "enrichments_complete" ||
                    data.type === "pyq_revise_start"
                  ) {
                    continue;
                  }

                  const newContent = data.response;
                  fullResponse += newContent;

                  if (!isFlushedRef.current) {
                    const plainLen = fullResponse.replace(/<[^>]*>/g, '').trim().length;
                    if (loadingStepRef.current >= activeLoadingSteps.length - 1 || plainLen > 10) {
                      isFlushedRef.current = true;
                      if (loadingStepIntervalRef.current) {
                        clearInterval(loadingStepIntervalRef.current);
                        loadingStepIntervalRef.current = null;
                      }
                      setLoadingStep(-1);
                      setIsLoading(false);
                    } else {
                      continue;
                    }
                  }

                  setResponseData(data);
                  if (conversationId == "") {
                    setConversationId(data.conversation_id);


                  }
                  const prepared = prepareMentorMindResponse(fullResponse);

                  if (prepared.markmap) {
                    const currentIndex =
                      syllabusMsgIndexRef.current ?? messages.length;
                    setMarkmapData((prev) => ({
                      ...prev,
                      [currentIndex]: prepared.markmap,
                    }));
                  }
                  setTopic(prepared.topic);

                  setMessages((prevItems) => {
                    const updatedItems = [...prevItems];
                    const lastIndex = updatedItems.length - 1;
                    if (lastIndex < 0 || !updatedItems[lastIndex]) return prevItems;
                    updatedItems[lastIndex] = {
                      ...updatedItems[lastIndex],
                      sender: "bot",
                      message: wrapMermaidWithLoader(prepared.html),
                      prompt: promptType,
                      subject:
                        extractSubjectFromTheme(data.theme) ||
                        updatedItems[lastIndex].subject ||
                        null,
                      topic:
                        prepared.topic || updatedItems[lastIndex].topic,
                      // CS / Initiatives / Keywords only from typed events
                      keywords: updatedItems[lastIndex].keywords,
                      caseStudies: updatedItems[lastIndex].caseStudies,
                      initiatives: updatedItems[lastIndex].initiatives,
                      keywordsArray: updatedItems[lastIndex].keywordsArray,
                      hasStatusMatch:
                        (updatedItems[lastIndex].keywordsArray || []).length >
                          0 && currentPretext != "essay"
                          ? false
                          : true,
                      messageId: updatedItems[lastIndex].messageId || messageId,
                      isFeedbackFormSubmitted: false,
                      hasFetched: Boolean(updatedItems[lastIndex].hasFetched),
                    };
                    return updatedItems;
                  });
                }
              }
            } catch (e) {
              console.error("Error parsing SSE data:", e);
            }
          }
        }
      }

      if (!isFlushedRef.current) {
        isFlushedRef.current = true;
        if (loadingStepIntervalRef.current) {
          clearInterval(loadingStepIntervalRef.current);
          loadingStepIntervalRef.current = null;
        }
        setLoadingStep(-1);
        setIsLoading(false);
      }

      // Remove the mermaid loader placeholder from the stored message once the
      // stream is done, so re-renders never show the loader again.
      setMessages((prevItems) => {
        const updatedItems = [...prevItems];
        const lastIndex =
          syllabusMsgIndexRef.current ?? updatedItems.length - 1;
        if (lastIndex < 0 || !updatedItems[lastIndex]) return prevItems;
        updatedItems[lastIndex] = {
          ...updatedItems[lastIndex],
          message: unwrapMermaidLoader(updatedItems[lastIndex].message),
        };
        return updatedItems;
      });

      setIsStreamingDone(true);
      setIsStreamingDoneSidebar(true);

      // Check for markmap content (infographic)
      const markmapMatch = fullResponse.match(/```markmap\n([\s\S]*?)```/);
      const markmapContent = markmapMatch ? markmapMatch[1] : null;

      // Only fetch additional data if this bot message is non-essay and has keywords, and we haven't already fetched
      // if (
      //   currentPretext != "essay" &&
      //   !hasFetchedKeywordData &&
      //   keywordsContainer.length > 0
      // ) {
      //   const finalIndex = messages.length;
      //   fetchQuestions(fullResponse, finalIndex, keywordsContainer);
      //   fetchRelatedTopics(fullResponse, finalIndex, keywordsContainer);
      //   // Optional: fetchImages(finalIndex);
      // }

      // Fetch images only once - if there are keywords OR markmap content
      // if (
      //   (keywordsContainer.length > 0 && currentPretext != "essay") ||
      //   markmapContent
      // ) {
      //   fetchImages(messages.length);
      // }

      // setUserPrompt("");
      setCurrentAffairsCode("");
      setIsLoading(false);
      setRefreshHistory();
      validateAccessToken();
    } catch (error) {
      if (loadingStepIntervalRef.current) {
        clearInterval(loadingStepIntervalRef.current);
        loadingStepIntervalRef.current = null;
      }
      setLoadingStep(-1);
      isFlushedRef.current = true;
      setIsLoading(false);
      // Remove the mermaid loader placeholder so it never stays stuck.
      setMessages((prevItems) => {
        const updatedItems = [...prevItems];
        const lastIndex = updatedItems.length - 1;
        if (lastIndex < 0 || !updatedItems[lastIndex]) return prevItems;
        updatedItems[lastIndex] = {
          ...updatedItems[lastIndex],
          message: unwrapMermaidLoader(updatedItems[lastIndex].message),
        };
        return updatedItems;
      });
      setIsStreamingDone(true);
      setIsStreamingDoneSidebar(true);
      // Check if the error message includes the status
      const errorMessage = error.message || "";
      if (errorMessage.includes("status: 429")) {
        // Handle 429 Too Many Requests
        setShowPremiumButton(true);
        setError((prevMap) => ({
          ...prevMap,
          [messages.length - 1]: {
            error: "You have exhausted your daily message limit",
          },
        }));
      } else {
        // Handle other errors
        setError((prevMap) => ({
          ...prevMap,
          [messages.length - 1]: {
            error: "An error occurred. Please try again.",
          },
        }));
      }
    } finally {
      // PYQ/Revise is fetched via the revisePyq API using the message id,
      // fired as soon as the first SSE line is received.
    }
  };

  async function fetchRelatedSummaries(index, keywordsArray = []) {
    setRelatedSummariesLoadingMap((prev) => ({ ...prev, [index]: true }));
    const keywords = keywordsArray?.length > 0 ? keywordsArray : [];

    if (keywords.length === 0) {
      setRelatedSummariesLoadingMap((prev) => ({ ...prev, [index]: false }));
      return;
    }

    try {
      const response = await getRelatedSummaries(keywords);
      const data = response?.related_summaries || response?.matches || response?.summaries || response?.results || (Array.isArray(response) ? response : response?.data || []);
      setRelatedSummariesMap((prev) => ({ ...prev, [index]: data }));
    } catch (error) {
      console.error("Error fetching related summaries:", error);
      setRelatedSummariesMap((prev) => ({ ...prev, [index]: [] }));
    } finally {
      setRelatedSummariesLoadingMap((prev) => ({ ...prev, [index]: false }));
    }
  }

  function Demo() {
  }

  async function fetchRelatedTopics(fullResponse, index, keywordsArray = []) {
    setRelatedTopicsLoadingMap((prev) => ({ ...prev, [index]: true }));
    const keywordRegex = /<p _className_="keyword">(.*?)<\/p>/g;
    const keywords = keywordsArray.length > 0 ? keywordsArray : [];
    let keywordMatch;
    while ((keywordMatch = keywordRegex.exec(fullResponse)) !== null) {
      const keywordContent = keywordMatch[1].trim();
      if (keywordContent) {
        // Clean the keyword text - remove any HTML tags and extra spaces
        const cleanKeyword = keywordContent
          .replace(/<[^>]*>/g, "") // Remove any HTML tags
          .replace(/\s+/g, " ") // Replace multiple spaces with single space
          .trim();
        if (cleanKeyword) {
          keywords.push(cleanKeyword);
        }
      }
    }

    // If no keywords found, use first 3 words of the response
    if (keywords.length === 0) {
      const words = fullResponse
        .replace(/<[^>]*>/g, "") // Remove HTML tags
        .split(/\s+/)
        .filter((word) => word.length > 0)
        .slice(0, 3);
      keywords.push(...words);
    }

    try {
      const relatedTopicsResponse = await getRelatedTopics(keywords);
      setRelatedTopicsMap((prev) => ({
        ...prev,
        [index]: relatedTopicsResponse.matches,
      }));
    } catch (error) {
      console.error("Error fetching related topics:", error);
      setRelatedTopicsMap((prev) => ({ ...prev, [index]: [] }));
    } finally {
      setRelatedTopicsLoadingMap((prev) => ({ ...prev, [index]: false }));
    }
  }

  useEffect(() => {
    // Check if the last message is from the bot
    // if (isHistory) {
    //   return;
    // }
    const lastMessage = messages[messages.length - 2];
    if (
      lastMessage &&
      lastMessage?.sender !== "bot" &&
      !questionsMap[messages.length - 1] &&
      isStreamingDone
    ) {
      // Fetch images only once - if it's Short Notes/Case Study OR if there's markmap data
      if (
        promptType == "Short Notes" ||
        promptType == "Case Study" ||
        markmapData[messages.length - 1]
      ) {
        fetchImages(messages.length - 1);
      }
    }
  }, [messages, isStreamingDone]); // Runs every time messages array updates

  const isValidMermaidCode = (code, preElement, mermaidContainer) => {
    if (typeof mermaid !== "undefined") {
      try {
        mermaid
          .parse(code)
          .then((e) => {
            const loaderWrapper = preElement.closest(
              ".mermaid-loader-wrapper",
            );
            const replaceTarget = loaderWrapper || preElement;
            replaceTarget.parentNode.replaceChild(
              mermaidContainer,
              replaceTarget,
            );
            setIsMermaidDone(true);
          })
          .catch((e) => {
            // Remove the loader wrapper so it doesn't stay stuck if the
            // diagram fails to parse; the hidden pre/code remains instead.
            const loaderWrapper = preElement.closest(".mermaid-loader-wrapper");
            if (loaderWrapper) {
              loaderWrapper.parentNode.replaceChild(preElement, loaderWrapper);
            }
            setIsMermaidDone(false);
          });
      } catch (error) {
        console.error("Invalid Mermaid code:", error.message);
        const loaderWrapper = preElement.closest(".mermaid-loader-wrapper");
        if (loaderWrapper) {
          loaderWrapper.parentNode.replaceChild(preElement, loaderWrapper);
        }
        setIsMermaidDone(false);
      }
    }

    setIsMermaidDone(false);
  };

  const selectEdit = (promptType, index) => {
    chatInputRef.current.handlecutomSelect();
    if (chatInputRef.current) {
      if (messages[index - 1].sender === "user") {
        chatInputRef.current.editMessage(messages[index - 1].message);
      } else {
        for (let i = index - 1; i >= 0; i--) {
          if (messages[i].sender === "user") {
            chatInputRef.current.editMessage(messages[i].message);
            break;
          }
        }
      }
      if (messages[index - 1].prompt != undefined) {
        chatInputRef.current.handleSelectPrompt(messages[index - 1].prompt, "");
      }
    }
  };

  const processMermaidDiagrams = (responseElement) => {
    if (!responseElement) return;
    const mermaidBlocks = responseElement.querySelectorAll(
      "pre code.language-mermaid",
    );

    try {
      mermaidBlocks.forEach(async (codeBlock) => {
        try {
          const mermaidContainer = document.createElement("div");
          mermaidContainer.classList.add("mermaid");
          mermaidContainer.textContent = codeBlock.textContent.trim();
          // mermaidContainer.style.display = 'none';

          const preElement = codeBlock.closest("pre");
          if (preElement) {
            if (typeof mermaid !== "undefined") {
              mermaid.initialize({ startOnLoad: false });
              isValidMermaidCode(
                codeBlock.textContent.trim(),
                preElement,
                mermaidContainer,
              );
              // if(isValidMermaidCode(codeBlock.textContent.trim())){
              //   setIsMermaidDone(true);
              // }
            }
          }
        } catch (error) {
          console.error("Error processing Mermaid diagram:", error);
        }
      });
    } catch (error) {
      console.error("Error processing Mermaid diagram:", error);
    }
  };

  const copyContent = (className) => {
    const element = document.querySelector("." + className);
    if (element) {
      const textToCopy = element.innerText;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(textToCopy)
          .then(() => {
            setIsCopied(true);
            setTimeout(() => {
              setIsCopied(false);
            }, 2000);
          })
          .catch((err) => {
            copyToClipboardFallback(textToCopy);
          });
      } else {
        copyToClipboardFallback(textToCopy);
      }
    } else {
      alert("Some Error occured while coping");
    }
  };
  const copyToClipboardFallback = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed"; // Avoid scrolling to the bottom
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand("copy");
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 2000);
    } catch (err) {
      console.error("Fallback: Unable to copy", err);
    }
    document.body.removeChild(textArea);
  };

  const generatePdf = async (className, index) => {
    const element = document.querySelector("." + className);

    async function toBase64(url) {
      const res = await fetch(url);
      const blob = await res.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    }

    const transparentPixel = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";

    let phoneIcon = transparentPixel;
    let emailIcon = transparentPixel;
    let globeIcon = transparentPixel;
    let telegramIcon = transparentPixel;

    try {
      phoneIcon = await toBase64("https://img.icons8.com/ios/50/ffffff/phone.png");
    } catch (e) {
      console.warn("Failed to load phone icon, using fallback transparent pixel", e);
    }
    try {
      emailIcon = await toBase64("https://img.icons8.com/ios/50/ffffff/new-post.png");
    } catch (e) {
      console.warn("Failed to load email icon, using fallback transparent pixel", e);
    }
    try {
      globeIcon = await toBase64("https://img.icons8.com/ios/50/ffffff/internet--v1.png");
    } catch (e) {
      console.warn("Failed to load globe icon, using fallback transparent pixel", e);
    }
    try {
      telegramIcon = await toBase64("https://img.icons8.com/ios/50/ffffff/telegram.png");
    } catch (e) {
      console.warn("Failed to load telegram icon, using fallback transparent pixel", e);
    }

    if (element) {
      // Create question header
      const questionHeader = document.createElement("div");
      questionHeader.style.fontWeight = "bold";
      questionHeader.style.marginBottom = "20px";
      questionHeader.style.fontSize = "16px";
      const userMsg = (messages[index - 1] && messages[index - 1].message) ? messages[index - 1].message : "Question";
      questionHeader.textContent = "Q: " + userMsg;

      const container = document.createElement("div");

      const imageHeader = document.createElement("div");
      imageHeader.style.fontWeight = "bold";
      imageHeader.style.marginBottom = "20px";
      imageHeader.style.fontSize = "16px";

      if (imageMap[index] && imageMap[index].length > 0) {
        for (const item of imageMap[index]) {
          if (item.image_link) {
            try {
              // Convert to base64 to prevent CORS taint
              const base64Data = await toBase64(item.image_link);
              const img = document.createElement("img");
              img.src = base64Data;
              img.alt = "Image";
              img.style.maxHeight = "90vh";
              img.style.maxWidth = "100%";
              img.style.pageBreakInside = "avoid";
              container.appendChild(img);
            } catch (err) {
              console.warn("Failed to fetch and convert image to base64, falling back to crossorigin attribute:", item.image_link, err);
              try {
                const img = document.createElement("img");
                img.setAttribute("crossorigin", "anonymous");
                img.src = item.image_link;
                img.alt = "Image";
                img.style.maxHeight = "90vh";
                img.style.maxWidth = "100%";
                img.style.pageBreakInside = "avoid";
                container.appendChild(img);
              } catch (e) {
                console.error("Failed to append image fallback:", e);
              }
            }
          }
        }
      }

      // Clone the element to manipulate it
      const clonedElement = element.cloneNode(true);

      // Convert any inline images inside clonedElement to base64 to prevent CORS errors during html2canvas render
      const inlineImages = clonedElement.querySelectorAll("img");
      for (const img of inlineImages) {
        const src = img.src;
        if (src && !src.startsWith("data:") && !src.startsWith("blob:")) {
          try {
            const base64Data = await toBase64(src);
            img.src = base64Data;
          } catch (err) {
            console.warn("Failed to convert inline image to base64, setting crossorigin:", src, err);
            img.setAttribute("crossorigin", "anonymous");
          }
        }
      }

      // Create a wrapper for the content and headers
      const contentWrapper = document.createElement("div");

      // Dynamically wrap each header and its content
      const headerTags = ["H1", "H2", "H3", "H4", "H5", "H6"];
      let currentWrapper = null;

      clonedElement.childNodes.forEach((node) => {
        if (headerTags.includes(node.nodeName)) {
          // If a new header is encountered, create a new wrapper
          currentWrapper = document.createElement("div");
          currentWrapper.style.pageBreakInside = "avoid"; // Prevent breaks within this wrapper
          currentWrapper.style.marginBottom = "20px"; // Add spacing for readability
          currentWrapper.appendChild(node.cloneNode(true));
          contentWrapper.appendChild(currentWrapper);
        } else if (currentWrapper) {
          // Append content to the current header's wrapper
          currentWrapper.appendChild(node.cloneNode(true));
        } else {
          // For nodes outside headers, append them normally
          contentWrapper.appendChild(node.cloneNode(true));
        }
      });

      // Add CSS to balance pages and reduce gaps
      const style = document.createElement("style");
      style.innerHTML = `
        div {
          line-height: 1.6; /* Improve readability */
        }
        .page-break-avoid {
          page-break-inside: avoid !important; /* Ensure headers and content stay together */
        }
        .reduce-gaps {
          margin: 0 !important; /* Minimize gaps caused by large elements */
        }
      `;
      document.head.appendChild(style);

      // Wrap headers and content inside a container
      const wrapper = document.createElement("div");
      wrapper.style.position = "relative";
      wrapper.style.overflow = "hidden";
      wrapper.classList.add("page-break-avoid", "reduce-gaps");
      wrapper.appendChild(questionHeader);

      // Remove margin from the last element of contentWrapper to prevent unnecessary page breaks
      if (contentWrapper.lastElementChild) {
        contentWrapper.lastElementChild.style.marginBottom = "0px";
      }
      wrapper.appendChild(contentWrapper);

      if (container.hasChildNodes()) {
        wrapper.appendChild(imageHeader);
        wrapper.appendChild(container);
      }

      // Configure PDF options with increased bottom margin
      const opt = {
        margin: [0.5, 0.3, 0.6, 0.3], // top, right, bottom, left (increased bottom from 0.3 to 1.2)
        filename: "askyooki.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          logging: false,
        },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "portrait",
        },
        pagebreak: { mode: ["avoid-all", "css", "legacy"] },
      };

      document.body.appendChild(wrapper);

      // Add table-specific styles before PDF generation
      const tableStyle = document.createElement("style");
      tableStyle.innerHTML = `
        table {
          width: 100% !important;
          margin: 0 0 20px 0 !important;
          padding: 0 !important;
          border-collapse: collapse !important;
          page-break-inside: avoid !important;
        }
        table td, table th {
          padding: 8px 6px !important;
          font-size: 12px !important;
          word-wrap: break-word !important;
          overflow-wrap: break-word !important;
        }
        table th {
          background-color: #F8F9FA !important;
          font-weight: 600 !important;
          font-size: 12px !important;
        }
        .invoice-table {
          width: 100% !important;
          margin: 10px 0 30px 0 !important;
          page-break-inside: avoid !important;
        }
        .invoice-table-table {
          width: 100% !important;
          font-size: 11px !important;
        }
        .invoice-table-row td {
          padding: 6px 4px !important;
          font-size: 11px !important;
        }
      `;
      document.head.appendChild(tableStyle);

      html2pdf()
        .set(opt)
        .from(wrapper)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          const totalPages = pdf.internal.getNumberOfPages();
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();

          // Load the header logo image
          const headerImg = new Image();
          // Load the watermark image for background
          const watermarkImg = new Image();

          let imagesLoaded = 0;
          const totalImages = 2;

          const processPages = () => {
            // Create header logo canvas safely
            let headerImgBase64 = transparentPixel;
            if (headerImg.complete && headerImg.naturalWidth > 0) {
              try {
                const headerCanvas = document.createElement("canvas");
                const headerCtx = headerCanvas.getContext("2d");
                headerCanvas.width = headerImg.naturalWidth || headerImg.width;
                headerCanvas.height = headerImg.naturalHeight || headerImg.height;
                headerCtx.fillStyle = "white";
                headerCtx.fillRect(0, 0, headerCanvas.width, headerCanvas.height);
                headerCtx.drawImage(
                  headerImg,
                  0,
                  0,
                  headerCanvas.width,
                  headerCanvas.height,
                );
                headerImgBase64 = headerCanvas.toDataURL("image/png");
              } catch (e) {
                console.error("Error drawing header logo:", e);
              }
            }

            // Create watermark canvas (semi-transparent) safely
            let watermarkBase64 = null;
            if (watermarkImg.complete && watermarkImg.naturalWidth > 0) {
              try {
                const watermarkCanvas = document.createElement("canvas");
                const watermarkCtx = watermarkCanvas.getContext("2d");
                watermarkCanvas.width = watermarkImg.naturalWidth || watermarkImg.width;
                watermarkCanvas.height = watermarkImg.naturalHeight || watermarkImg.height;
                watermarkCtx.globalAlpha = 0.2;
                watermarkCtx.drawImage(
                  watermarkImg,
                  0,
                  0,
                  watermarkCanvas.width,
                  watermarkCanvas.height,
                );
                watermarkBase64 = watermarkCanvas.toDataURL("image/png");
              } catch (e) {
                console.error("Error drawing watermark:", e);
              }
            }

            // Add header and footer to all pages
            for (let i = 1; i <= totalPages; i++) {
              pdf.setPage(i);

              // CUSTOMIZE: Header background color (RGB values)
              pdf.setFillColor(32, 178, 221); // Blue: (32, 178, 221) - Change these values
              pdf.rect(0, 0, pageWidth, 0.5, "F"); // Blue header rectangle

              // Add white background for logo with padding
              const logoPadding = 0.2; // CUSTOMIZE: Logo padding in inches
              const logoWidth = 1.25; // CUSTOMIZE: Logo width in inches
              const logoHeight = 0.5; // CUSTOMIZE: Logo height in inches
              const logoXPos = 0.6; // CUSTOMIZE: Logo X position
              const logoYPos = 0; // CUSTOMIZE: Logo Y position

              // CUSTOMIZE: Logo background color (RGB values)
              pdf.setFillColor(255, 255, 255); // White background
              pdf.rect(logoXPos, logoYPos, logoWidth, logoHeight, "F");

              // Add header logo image safely
              if (headerImgBase64) {
                pdf.addImage(
                  headerImgBase64,
                  "PNG",
                  logoXPos,
                  logoYPos,
                  logoWidth,
                  logoHeight,
                );
              }

              // Add blue footer background (adjusted position to prevent overlap)
              pdf.setFillColor(32, 178, 221);
              pdf.rect(0, pageHeight - 0.65, pageWidth, 0.65, "F");

              // Text style
              pdf.setFont("helvetica", "normal");
              pdf.setTextColor(255, 255, 255);
              pdf.setFontSize(7.5);

              const footerH = 0.6;
              const footerY = pageHeight - footerH;

              // Pixel → inch conversions
              const iconSize = 13 / 96;
              const vOffset = 9 / 96;
              const textGap = 25 / 96;

              // Column centers (Left / Middle / Right)
              const col1 = pageWidth * 0.08;
              const col2 = pageWidth * 0.42;
              const col3 = pageWidth * 0.78;

              // Row positions inside footer (adjusted to fit within footer)
              const rowTop = footerY + 0.16;
              const rowBottom = footerY + 0.35;

              /* ---------------- LEFT COLUMN ---------------- */

              // Phone
              pdf.addImage(
                phoneIcon,
                "PNG",
                col1 - textGap,
                rowTop - vOffset,
                iconSize,
                iconSize,
              );
              pdf.text("+91-9773890604", col1, rowTop);

              // Telegram 1
              pdf.addImage(
                telegramIcon,
                "PNG",
                col1 - textGap,
                rowBottom - vOffset,
                iconSize,
                iconSize,
              );
              pdf.text("t.me/edukemycivilservices", col1, rowBottom);

              /* ---------------- CENTER COLUMN ---------------- */

              // Email
              pdf.addImage(
                emailIcon,
                "PNG",
                col2 - textGap,
                rowTop - vOffset,
                iconSize,
                iconSize,
              );
              pdf.text("admissions@edukemy.com", col2, rowTop);

              // Telegram 2
              pdf.addImage(
                telegramIcon,
                "PNG",
                col2 - textGap,
                rowBottom - vOffset,
                iconSize,
                iconSize,
              );
              pdf.text("t.me/GeographywithEDUKEMY", col2, rowBottom);

              /* ---------------- RIGHT COLUMN ---------------- */

              // Website
              pdf.addImage(
                globeIcon,
                "PNG",
                col3 - textGap,
                rowTop - vOffset,
                iconSize,
                iconSize,
              );
              pdf.text("www.edukemy.com", col3, rowTop);

              // Telegram 3
              pdf.addImage(
                telegramIcon,
                "PNG",
                col3 - textGap,
                rowBottom - vOffset,
                iconSize,
                iconSize,
              );
              pdf.text("t.me/askyooki", col3, rowBottom);
            }

            // Add watermark to all pages (center and semi-transparent) safely
            if (watermarkBase64 && watermarkImg.width > 0) {
              for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i);
                const imgWidth = pageWidth * 0.8;
                const imgWidthToUse = isNaN(imgWidth) ? 0.8 : imgWidth;
                const imgHeight =
                  (watermarkImg.height / watermarkImg.width) * imgWidthToUse;
                const imgHeightToUse = isNaN(imgHeight) ? 0.8 : imgHeight;
                const xPos = (pageWidth - imgWidthToUse) / 2;
                const yPos = (pageHeight - imgHeightToUse) / 2;

                pdf.addImage(
                  watermarkBase64,
                  "PNG",
                  xPos,
                  yPos,
                  imgWidthToUse,
                  imgHeightToUse,
                  null,
                  "NONE",
                );
              }
            }

            try {
              document.body.removeChild(wrapper);
            } catch (e) { }

            try {
              document.head.removeChild(style);
            } catch (e) { }

            try {
              document.head.removeChild(tableStyle);
            } catch (e) { }

            pdf.save(opt.filename);
            setIsGeneratedPdf(true);
            setTimeout(() => {
              setIsGeneratedPdf(false);
            }, 2000);
          };

          // Set up event listeners BEFORE assigning src properties to prevent race conditions
          headerImg.onload = () => {
            imagesLoaded++;
            if (imagesLoaded === totalImages) processPages();
          };

          watermarkImg.onload = () => {
            imagesLoaded++;
            if (imagesLoaded === totalImages) processPages();
          };

          headerImg.onerror = () => {
            console.error("Failed to load header logo");
            imagesLoaded++;
            if (imagesLoaded === totalImages) processPages();
          };

          watermarkImg.onerror = () => {
            console.error("Failed to load watermark");
            imagesLoaded++;
            if (imagesLoaded === totalImages) processPages();
          };

          // Statically assign image sources
          headerImg.src = pdfHeaderLogo;
          watermarkImg.src = watermarkImage;
        })
        .catch((err) => {
          console.error("PDF generation failed:", err);

          // Cleanup on error
          try {
            if (document.body.contains(wrapper)) {
              document.body.removeChild(wrapper);
            }
          } catch (e) { }

          try {
            if (document.head.contains(style)) {
              document.head.removeChild(style);
            }
          } catch (e) { }

          try {
            if (document.head.contains(tableStyle)) {
              document.head.removeChild(tableStyle);
            }
          } catch (e) { }

          alert("Error generating PDF. Please try again.");
        });
    } else {
      alert("Content not found");
    }
  };

  // useEffect(() => {
  // Scroll to the bottom when a new message is added by the user
  // if (messages[messages.length - 1]?.sender === "user") {
  //   scrollToBottom();
  // }
  // }, [messages]);

  const messagesEndRef = useRef(null);
  const messagesStartRef = useRef(null);

  useEffect(() => {
    if (messagesStartRef.current && !isScrolling) {
      const rect = messagesStartRef.current.getBoundingClientRect();
      if (rect.top > 0) {
        messagesStartRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  });

  const [isUserScrolling, setIsUserScrolling] = useState(false);

  const handleUserScroll = () => {
    setIsUserScrolling(true);
    // Optionally, you can set a timer to reset this after some time
    setTimeout(() => {
      isUserScrolling = false;
    }, 2000);
  };

  useEffect(() => {
    const messagesContainer = document.querySelector(".messages");
    if (messagesContainer) {
      messagesContainer.addEventListener("scroll", handleUserScroll);
      return () => {
        messagesContainer.removeEventListener("scroll", handleUserScroll);
      };
    }
  }, []);

  const scrollToBottom = (e) => {
    if (!isUserScrolling) {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }
    setShowBottom(false);
  };

  // const responseArea = document.getElementById('botChat');
  // if (responseArea) {
  //   const isOverflowing = responseArea.scrollHeight > responseArea.clientHeight;
  //   console.log("isOverflowing", isOverflowing);
  // }

  // console.log("responseArea", responseArea);
  // if (responseArea) {
  //     console.log("responseArea", responseArea);
  //     const isOverflowing = responseArea.scrollHeight > responseArea.clientHeight;
  //     console.log("isOverflowing", isOverflowing);
  //     settoptobottom(isOverflowing);
  //   }

  // messages = your list of messages

  // Scroll when messages update

  // const filterRelatedTopics = (index) => {
  //   // Create a deep copy of the data to avoid mutating the original
  //   const filteredData = JSON.parse(JSON.stringify(relatedTopicsData));

  //   // Filter stayUpdated cards
  //   if (filteredData.stayUpdated?.cards) {
  //     filteredData.stayUpdated.cards = filteredData.stayUpdated.cards.filter((_, i) => i % 2 === index);
  //   }

  //   // Filter connectTheDots cards
  //   if (filteredData.connectTheDots?.cards) {
  //     filteredData.connectTheDots.cards = filteredData.connectTheDots.cards.filter((_, i) => i % 2 === index);
  //   }

  //   // Filter quiz topics
  //   if (filteredData.confidentAboutBudget?.quiz?.topics) {
  //     filteredData.confidentAboutBudget.quiz.topics = filteredData.confidentAboutBudget.quiz.topics.filter((_, i) => i % 2 === index);
  //   }
  //   console.log("filteredData", filteredData)

  //   return filteredData;
  // }
  // for evaluate
  useEffect(() => {
    if (evalutedata) {
      const data = evalutedata[0];

      setevaluatedetails(evalutedata);
      setFiledetail(data.fildetail);
      setAttchsubject(data.attchsubject);
      setAttachmark(data.attachmark);
      // handleSend({
      //   message: data.message,
      //   prompt: data.prompt,
      //   mcqData: data.mcqData,
      //   mainsPractice: data.mainsPractice
      // });
    }
  }, []);

  useEffect(() => {
    if (Object.keys(evaluatedetails).length !== 0) {
      setShowPromptType(true);
      const data = evalutedata[0];
      handleSend({
        message: data.message,
        prompt: data.prompt,
        mcqData: data.mcqData,
        mainsPractice: data.mainsPractice,
      });
    }
  }, [evaluatedetails]);

  useEffect(() => {
    const mapping = {
      Essay: "essay",
      "Frame Your Essay": "essay",
      "See a Model Answer": "answer",
      Answer: "answer",
      "Plan Your Answer": "approach",
      "Explore a Case Study": "case_study",
      "Quick Topic Summary": "short_note",
      Generic: "",
    };

    const state = location.state;
    const initial = state?.initialMessages;

    if (initial && initial.length > 0) {
      const first = initial[0];
      const second = initial[1];


      setMessages(initial);
      setIsStreamingDone(true);
      setIsStreamingDoneSidebar(true);
      setIsHistory(false);
      setShowPromptType(true);
      setMsgSend(true);

      setPromptType(first?.prompt || "Generic");

      // Special case: "See a Model Answer"
      // if (first?.prompt === "See a Model Answer") {
      //   console.log("See Model Answer:", first?.message);
      //   setUserPrompt(first?.message || "");
      //   setCurrentPretext("answer");
      //     setCurrentAffairsCode(
      //       first?.promptType == "answer" ? first?.message : "",
      //     );
      // }

      if (state?.toipic === "Learn Topic") {
        // Learn Topic mode
        setUserPrompt(first?.message || "");
        setSendTrigger((prev) => prev + 1);
        setCurrentPretext("short_note");
        setCurrentAffairsCode("");
      }

      // Handle remaining cases only if second prompt is not a practice type
      if (
        second &&
        second?.prompt !== "Prelims Practice" &&
        second?.prompt !== "Mains Practice"
      ) {
        if (state?.topic === "Learn Topic") {
          // Learn Topic mode
          setUserPrompt(first?.message || "");
          setSendTrigger((prev) => prev + 1);
          setCurrentPretext("short_note");
          setCurrentAffairsCode("");
        } else {
          // Normal mode
          setUserPrompt(second?.message || "");
          setSendTrigger((prev) => prev + 1);

          // Use first message for metadata
          setCurrentPretext(first?.promptType || first?.prompt || "");
          setCurrentAffairsCode(first?.message);
          fetchRelatedTopics(first?.message, 0, first?.keywordsArray || []);
          fetchRelatedSummaries(0, first?.keywordsArray || []);
          fetchQuestions(
            first?.message,
            0,
            first?.keywordsArray || [],
            first?.theme,
            second?.message,
          );
          fetchImages(0, first?.topic || "");
        }
      }
    } else {
    }

  }, []);

  // PYQ/Revise now comes from the MentorMind SSE stream — standalone API call no longer needed
  // useEffect(() => {
  //     const fetchPYQ = async (userMsg, messageId) => {
  //       console.log("fetchPYQ called with:", { userMsg, messageId });
  //       const response = await revisePyq(userMsg, messageId);
  //       console.log("response", response);
  //       setMessages((prev) =>
  //         prev.map((msg, i) =>
  //           msg.messageId === messageId && (!msg.pyq || !msg.revise)
  //             ? { ...msg, pyq: response.pyq, revise: response.revise }
  //             : msg,
  //         ),
  //       );
  //     };
  //     if (
  //       keywords.length > 0 && messageId && (currentPretext == "" || currentPretext == "generic" || currentPretext == "short_note")
  //     ) {
  //       console.log("fetching PYQ for messageId:", messageId);
  //       fetchPYQ(userPrompt, messageId);
  //     }
  // }, [messageId]);

  const moreButtonRef = useRef(null);
  const handelpostionmore = () => {
    setdropdownVisibl(!isdropdownVisibl);
    const rect = moreButtonRef.current.getBoundingClientRect();
    setDropdownPosition({
      left: rect.left,
      top: rect.top,
      width: rect.width,
      height: rect.height,
    });
  };
  const handleStartTest = async (topic) => {
    try {
      // First add a user message with Prelims Practice prompt
      const newMessage = {
        sender: "user",
        message: `Give me MCQ questions for ${topic}`,
        prompt: "Prelims Practice",
        mcqData: {
          subjectId: null,
          topicId: null,
          subtopicId: null,
          numQuestions: "5",
        },
      };
      setMessages((prev) => [...prev, newMessage]);

      // Fetch MCQ questions using the topic directly (returns all genuinely relevant questions)
      const mcqData = await searchMcqs(topic);

      // Add bot response with MCQ data
      setMessages((prev) => [
        ...prev,
        {
          sender: "bot",
          message: `Give me MCQ questions for ${topic}`,
          prompt: "Prelims Practice",
          mcqData: {
            questions: mcqData,
            subjectId: null,
            topicId: null,
            subtopicId: null,
            numQuestions: String(mcqData?.length || 0),
          },
        },
      ]);
    } catch (error) {
      console.error("Error starting test:", error);
      // Add error message to chat
      setMessages((prev) => [
        ...prev,
        {
          sender: "bot",
          message:
            "Sorry, there was an error fetching the MCQs. Please try again.",
          prompt: "Prelims Practice",
          mcqData: null,
        },
        {
          sender: "bot",
          message:
            "Sorry, there are no MCQs available for this topic. Please select another one.",
          prompt: "Generic",
          mcqData: null,
        },
      ]);
    }
  };

  return (
    <>
      {!tour && <Tourpoup setTour={setTour} />}

      <div className="icons-1">
        <img
          className={`menubar button mobile-only ${!isSidebarColl ? "d-blockk" : "d-nonee"
            }`}
          src="/assets/images/Vector.svg"
          width={20}
          height={20}
          alt="Logo"
          onClick={() => {
            Check();
          }}
        />
      </div>

      <div
        className={`chat-window ${messages.length === 0 ? "chat-window-before" : "chat-window-after"
          } ${isSidebarColl ? "chat-window-sidebar-collapsed" : "chat-window-sidebar-expanded"}`}
      >
        {messages.length === 0 ? (
          <div>
            {close &&
              profileData?.trial_status === "active" &&
              remainingDays > 0 && (
                <div className="notification-uses">
                  Your free trial ends in {remainingDays} day
                  {remainingDays > 1 ? "s" : ""}, for uninterrupted access
                  <span
                    className="notification-uses-text"
                    onClick={() => navigate("/Price")}
                  >
                    {" "}
                    Upgrade to PRO
                  </span>
                  <div
                    className="close-icon"
                    onClick={() => {
                      setClose(false);
                    }}
                  >
                    <img src="/assets/images/close-icon.svg" alt="" />
                  </div>
                </div>
              )}
          </div>
        ) : (
          <>
            <div
              className={`chat-window-container ${isSidebarColl
                  ? "chat-window-container-collapsed"
                  : "chat-window-container-expanded"
                }`}
              ref={divRef}
            >
              {showToolkit && activeToolkitIndex !== null ? (
                <div className="messages">
                  <div
                    className={`message-row message-row-${activeToolkitIndex}`}
                    style={{ display: "flex", width: "100%", justifyContent: "end" }}
                  >
                    <div className="main-content-area d-flex w-100">
                      <div className="chat-bubble bot w-100 p-0 d-flex">
                        {/* // by sudz - 260930 - Streamlined toolkit padding */}
                        <div className="toolkit-inline-content" style={{ width: "100%", padding: "10px 12px" }}>
                          <div style={{ border: "1px solid #e0e0e0", borderRadius: "8px", overflow: "hidden" }}>
                            <div style={{ display: "flex", gap: "0", marginBottom: "0", borderBottom: "2px solid #e0e0e0", alignItems: "stretch" }}>
                              <button
                                onClick={handleToolkitClose}
                                style={{
                                  padding: "10px 24px",
                                  border: "none",
                                  borderBottom: "2px solid transparent",
                                  marginBottom: "-2px",
                                  background: "transparent",
                                  color: "#007bff",
                                  cursor: "pointer",
                                  fontSize: "15px",
                                  fontWeight: "500",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                ← Back to Topic
                              </button>
                              <div style={{ flex: 1 }} />
                              {["memorise", "images", "pyq", "revise"].map((tab) => (
                                <button
                                  key={tab}
                                  onClick={() => setToolkitActiveTab(tab)}
                                  style={{
                                    padding: "10px 24px",
                                    border: "none",
                                    borderBottom: toolkitActiveTab === tab ? "2px solid #007bff" : "2px solid transparent",
                                    marginBottom: "-2px",
                                    background: "transparent",
                                    color: toolkitActiveTab === tab ? "#007bff" : "#666",
                                    cursor: "pointer",
                                    fontSize: "15px",
                                    fontWeight: toolkitActiveTab === tab ? "600" : "400",
                                    transition: "all 0.2s ease",
                                  }}
                                >
                                  {tab === "memorise" ? "Memorise" : tab === "images" ? "Images" : tab === "pyq" ? "Analyze PYQs" : "Revise"}
                                </button>
                              ))}
                            </div>
                            <div className="toolkit-content-body" style={{ overflow: "auto", maxHeight: "75vh", padding: "10px 14px" }}>
                              {toolkitActiveTab === "memorise" ? (
                                <div style={{ position: "relative", minHeight: "120px" }}>
                                  <div ref={memoriseRef} data-memorise-content style={{ position: "relative" }}>
                                    <InfographicTab ref={infographicRef} markmapContent={markmapData[activeToolkitIndex]} />
                                  </div>
                                  <button
                                    onClick={handleDownloadMindmap}
                                    style={{
                                      position: "absolute",
                                      bottom: "8px",
                                      right: "8px",
                                      background: "#eef3f7",
                                      border: "none",
                                      borderRadius: "6px",
                                      width: "32px",
                                      height: "32px",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                    title="Download"
                                  >
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#7B869B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                      <polyline points="7 10 12 15 17 10" />
                                      <line x1="12" y1="15" x2="12" y2="3" />
                                    </svg>
                                  </button>
                                </div>
                              ) : toolkitActiveTab === "images" ? (
                                <ImageGallery imageMap={imageMap} index={activeToolkitIndex} />
                              ) : toolkitActiveTab === "pyq" ? (
                                <div
                                  className="pyq-wrapper"
                                  dangerouslySetInnerHTML={{
                                    __html: messages[activeToolkitIndex]?.pyq || "<p>No PYQ data available.</p>",
                                  }}
                                />
                              ) : (
                                <div
                                  className="revise-wrapper"
                                  dangerouslySetInnerHTML={{
                                    __html: messages[activeToolkitIndex]?.revise || "<p>No revise data available.</p>",
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="right-sidebar-area RelatedTopic-mob">
                        {!relatedTopicsLoadingMap[activeToolkitIndex] && (
                          <Relatedtopic
                            relatedTopicsData={relatedTopicsMap[activeToolkitIndex]}
                            relatedLoader={relatedTopicsLoadingMap[activeToolkitIndex]}
                            relatedSummariesData={relatedSummariesMap[activeToolkitIndex]}
                            relatedSummariesLoader={relatedSummariesLoadingMap[activeToolkitIndex]}
                            showOnlySummaries={true}
                            showpracticetest={false}
                            onStartTest={handleStartTest}
                            keywords={messages[activeToolkitIndex]?.keywordsArray || []}
                            setTopicKeyword={() => { }}
                            syllabusProgressData={syllabusProgressMap[activeToolkitIndex]}
                            syllabusProgressLoading={syllabusProgressLoadingMap[activeToolkitIndex]}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="messages">
                  {messages.map((msg, index) => {
                    if (!refs.current[index]) {
                      refs.current[index] = React.createRef();
                    }

                    return (
                      <div
                        key={index}
                        className={`message-row message-row-${index}`}
                        style={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "end",
                        }}
                      >
                        {!isScrolling && <div ref={messagesStartRef}></div>}
                        <div
                          className={`main-content-area d-flex ${msg.sender === "bot" ? "w-100" : ""
                            }`}
                        >
                          {msg.prompt === "Prelims Practice" ? (
                            <>
                              <McqResponse
                                index={index}
                                isStreamingDone={isStreamingDone}
                                sender={msg.sender}
                                message={msg.message}
                                chatUniqueIndex={
                                  "toCopy" +
                                  index +
                                  msg.message
                                    .slice(0, 5)
                                    .replace(/<\/?[^>]+(>|$)/g, "")
                                }
                                mcqData={msg.mcqData}
                                isScrolling={isScrolling}
                                setIsScrolling={setIsScrolling}
                              />
                              {messages.length > 0 ? (
                                <div className="right-sidebar-area RelatedTopic-mob"></div>
                              ) : null}
                            </>
                          ) : msg.prompt === "Main Practice" ||
                            msg.prompt === "Mains Practice" ? (
                            <>
                              <Mainspractice
                                prelimquestion={msg.mainsPractice?.subjects}
                                sender={msg.sender}
                                message={msg.message}
                                onSend={handleSend}
                                setMessages={setMessages}
                                isScrolling={isScrolling}
                                setIsScrolling={setIsScrolling}
                              />
                              {messages.length > 0 ? (
                                <div className="right-sidebar-area RelatedTopic-mob"></div>
                              ) : null}
                            </>
                          ) : (
                            <ChatBubble
                              popup={popup}
                              setPopup={setPopup}
                              evaluatequestion={evaluatequestion}
                              attchsubject={attchsubject}
                              setMessageId={setMessageId}
                              setShareUrl={setShareUrl}
                              setSharePopupPos={setSharePopupPos}
                              isScrolling={isScrolling}
                              setShowSharePopup={setShowSharePopup}
                              showSharePopup={showSharePopup}
                              index={index}
                              isStreamingDone={isStreamingDone}
                              sender={msg.sender}
                              message={msg.message}
                              suggestedquestions={
                                msg.sender === "bot"
                                  ? questionsMap[index]?.data || []
                                  : []
                              }
                              onSend={handleSend}
                              isHistory={isHistory}
                              loading={loading}
                              isLoading={isLoading}
                              reference={refs.current[index]}
                              relatedTopicsData={relatedTopicsMap[index]}
                              relatedTopicsLoading={relatedTopicsLoadingMap[index]}
                              relatedSummariesData={relatedSummariesMap[index]}
                              relatedSummariesLoading={relatedSummariesLoadingMap[index]}
                              chatUniqueIndex={
                                "toCopy" +
                                index +
                                msg.message
                                  .slice(0, 5)
                                  .replace(/<\/?[^>]+(>|$)/g, "")
                              }
                              error={error}
                              getfeedbackform={() => getfeedbackform(index)}
                              copyContent={copyContent}
                              generatePdf={generatePdf}
                              selectEdit={selectEdit}
                              type={msg.prompt ? msg.prompt : msg.template}
                              isCopied={isCopied}
                              isFeedbackFormSubmitted={
                                msg.isFeedbackFormSubmitted || false
                              }
                              userPrompt={userPrompt}
                              markmapData={markmapData}
                              questionsMap={questionsMap}
                              imageMap={imageMap}
                              fetchQuestions={fetchQuestions}
                              promptType={promptType}
                              isGeneratedPdf={isGeneratedPdf}
                              mcqResponse={
                                msg.prompt === "MCQ" ? mcqResponse : null
                              }
                              evaluateResponse={
                                msg.prompt === "Evaluate"
                                  ? evaluateResponse
                                  : null
                              }
                              topic={msg.topic}
                              keywords={msg.keywords}
                              keywordsArray={msg.keywordsArray}
                              caseStudies={msg.caseStudies}
                              initiatives={msg.initiatives}
                              onStartTest={handleStartTest}
                              hasStatusMatch={msg.hasStatusMatch || false}
                              messageId={messageId}
                              messageIdList={messageIdList}
                              messages={messages}
                              setMessages={setMessages}
                              evalStatus={evalStatus}
                              revise={revise}
                              setRevise={setRevise}
                              onExamToolkitOpen={handleToolkitOpen}
                              syllabusProgressData={syllabusProgressMap[index]}
                              syllabusProgressLoading={syllabusProgressLoadingMap[index]}
                            />
                          )}
                        </div>
                      </div>
                    );
                  })}
                  {loadingStep >= 0 && (
                    <div className="loading-steps">
                      <div id="loadingSpinner" className="d-flex botImage">
                        <img
                          src="/assets/images/logo/yooki_navigator.svg"
                          className="botImage-img"
                          alt="response loading"
                        />
                        <span className="loading-step-text">{getLoadingSteps(promptType, currentPretext)[Math.min(loadingStep, getLoadingSteps(promptType, currentPretext).length - 1)]}</span>
                      </div>
                    </div>
                  )}
                </div>
              )}
              <div ref={messagesEndRef} /> {/* Anchor element for scrolling */}
            </div>
          </>
        )}
        <div
          className={`chatfiled chat-input-row ${messages.length === 0 ? "empty-chat" : ""
            } ${isSidebarColl
              ? "chat-input-row-sidebar-collapsed"
              : "chat-input-row-sidebar-expanded"
            }`}
          style={{ display: "flex" }}
          ref={chatRef}
        >
          <div
            className={`main-content-area chat-main-content ${isSidebarColl
                ? "chat-main-content-collapsed"
                : "chat-main-content-expanded"
              }`}
            style={{ flex: 1 }}
          >
            <div className="chat-input-container">
              {messages.length === 0 && (
                <h3 className="heading-chatwindow">
                  Ask anything related to UPSC...
                </h3>
              )}

              {!showPromptType && (
                <div className="container-predefined mt-2 cust-container">
                  <div className="row">
                    <div className="col-md-12" id="chat">
                      <div id="predefined_answer">
                        <div
                          style={{ textAlign: "center" }}
                          id="predefined_answer_buttons"
                        >
                          {(showAll
                            ? predefinedPrompts
                            : predefinedPrompts.slice(0, initialDisplayLimit)
                          ).map((prompt, index) => (
                            <button
                              key={index}
                              className="btn-question btm-four-wgt mobile-button-select"
                              onClick={() =>
                                handlePromptSelectChatwindow(prompt.value)
                              }
                            >
                              <img src={prompt.image} alt={prompt.label} />
                              <span className="p-type-title ms-2">
                                {prompt.label}
                              </span>
                            </button>
                          ))}

                          {predefinedPrompts.length > initialDisplayLimit && (
                            <>
                              <div style={{ position: "relative" }}>
                                <div
                                  style={{
                                    position: "absolute",
                                    bottom: "30px",
                                    width: "max-content",
                                  }}
                                >
                                  {isdropdownVisibl && (
                                    <ul
                                      ref={dropdownRef}
                                      className="dropdown-menu-end show model-prompt"
                                      style={{
                                        marginBottom: "10px",
                                        borderRadius: "11px",
                                        border: "1px solid #E1E7EA",
                                        padding: "4px 8px",
                                        cursor: "pointer",
                                        zIndex: 9999,
                                      }}
                                    >
                                      <li
                                        className="m-0"
                                        onClick={() => {
                                          handlePromptSelect(
                                            "Prelims Practice",
                                            "practice.svg",
                                          );
                                          setdropdownVisibl(!isdropdownVisibl);
                                        }}
                                      >
                                        <img
                                          src="/assets/images/practice.svg"
                                          className="icon-prompt"
                                          alt="Practice PYQs"
                                        />
                                        <span className="dropdown-item1 btn-prompt">
                                          Prelims Practice
                                        </span>
                                      </li>
                                      <li
                                        className="m-0"
                                        onClick={() => {
                                          handlePromptSelect(
                                            "Main Practice",
                                            "main-practice.svg",
                                          );
                                          setdropdownVisibl(!isdropdownVisibl);
                                        }}
                                      >
                                        <img
                                          src="/assets/images/main-practice.svg"
                                          className="icon-prompt"
                                          alt="Main Practice"
                                        />
                                        <span className="dropdown-item1 btn-prompt">
                                          Mains Practice
                                        </span>
                                      </li>
                                    </ul>
                                  )}
                                </div>
                                <button
                                  ref={moreButtonRef}
                                  className={`btn-question btm-four-wgt mobile-button-select ${initialDisplayLimit === 3 ? "d-none" : ""
                                    }`}
                                  onClick={(e) => {
                                    // setdropdownVisibl(!isdropdownVisibl);
                                    handelpostionmore();
                                  }}
                                >
                                  <img
                                    src="/assets/images/more-1.svg"
                                    alt="Logo"
                                  />
                                  <span className="p-type-title">More</span>
                                </button>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* { showBottom &&  <img
                src="assets/images/down-arrow.svg"
                alt="Arrow Icon"
                className="down-arrow"
                onClick={(e) =>{ 
                  
                  scrollToBottom()}}

              />} */}

              {!showToolkit && (
                <ChatInput
                  showPremiumButton={showPremiumButton}
                  setShowPremiumButton={setShowPremiumButton}
                  showattachment={true}
                  setAttchsubject={setAttchsubject}
                  setAttachmark={setAttachmark}
                  setFiledetail={setFiledetail}
                  selectedSubject={selectedSubject}
                  setMCQVisible={setMCQVisible}
                  setIsMainsPracticeVisible={setIsMainsPracticeVisible}
                  setEvaluateVisible={setEvaluateVisible}
                  setDefaultText={setDefaultText}
                  setIsPrelims={setIsPrelims}
                  setMessage={setMessage}
                  setSelectedPrompt={setSelectedPrompt}
                  selectedPrompt={selectedPrompt}
                  setMessages={setMessages}
                  setSelectedSubject={setSelectedSubject}
                  isMCQVisible={isMCQVisible}
                  message={message}
                  isPrelims={isPrelims}
                  defaultText={defaultText}
                  isEvaluateVisible={isEvaluateVisible}
                  isMainsPracticeVisible={isMainsPracticeVisible}
                  setbuttonclicked={setbuttonclicked}
                  ref={chatInputRef}
                  onSend={handleSend}
                  isStreamingDone={isStreamingDone}
                  messages={messages}
                  setMsgSend={setMsgSend}
                  setdropdownVisibl={setdropdownVisibl}
                  isdropdownVisibl={isdropdownVisibl}
                  dropdownPosition={dropdownPosition}
                  showPromptType={showPromptType}
                  setShowPromptType={setShowPromptType}
                  setPromptType={handlePromptSelectChatwindow}
                />
              )}
              {showPromptType && (
                <div className="chatwindow-textbox-below-msg">
                  Yooki is AI and can make mistakes
                </div>
              )}
              {isfeedbackform && (
                <>
                  <div
                    className="modal fade show"
                    id="feedbackModal"
                    tabIndex="-1"
                    aria-labelledby="feedbackModalLabel"
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                    aria-modal="true"
                    role="dialog"
                    style={{ display: "block", backdropFilter: "blur(8px)" }}
                  >
                    <div className="modal-dialog">
                      {" "}
                      <div
                        className="feedback-container"
                        style={{ maxWidth: "460px", marginTop: "100px" }}
                      >
                        <>
                          <button
                            className="close-btn"
                            id="closeButton"
                            onClick={() => setfeedbackform(false)}
                          >
                            ×
                          </button>
                          <form
                            className="feedback-modal"
                            id="feedbackForm"
                            onSubmit={handleSubmit}
                            style={{ textAlign: "justify" }}
                          >
                            <h2>Help us Improve 🚀</h2>

                            <p className="p-feedback">
                              Was Yooki easy to use & did it help you in your
                              preparation journey?
                            </p>
                            <div className="label-div-feedback">
                              <label>
                                <input
                                  type="radio"
                                  name="easyUse"
                                  value="Yes"
                                  required
                                  onChange={handleChange}
                                  style={{ width: "20px" }}
                                />{" "}
                                <span className="p-feedback">Yes</span>
                              </label>
                              <label>
                                <input
                                  type="radio"
                                  name="easyUse"
                                  value="No"
                                  required
                                  onChange={handleChange}
                                  style={{ width: "20px" }}
                                />{" "}
                                <span className="p-feedback">No</span>
                              </label>
                            </div>

                            {formData.easyUse === "No" && (
                              <div id="additionalOptions">
                                <label>
                                  <input
                                    type="checkbox"
                                    className="challenges"
                                    name="challenges"
                                    value="Ease of Use"
                                    onChange={handleChange}
                                  />
                                  <span className="p-feedback">
                                    Ease of Use
                                  </span>
                                </label>
                                <br />
                                <label style={{ marginLeft: "55px" }}>
                                  <input
                                    type="checkbox"
                                    className="challenges"
                                    name="challenges"
                                    value="AI Content Quality"
                                    onChange={handleChange}
                                  />
                                  <span className="p-feedback">
                                    {" "}
                                    AI Content Quality
                                  </span>
                                </label>
                                <br />
                                <label style={{ marginLeft: "55px" }}>
                                  <input
                                    type="checkbox"
                                    className="challenges"
                                    name="challenges"
                                    value="Response Speed"
                                    onChange={handleChange}
                                  />
                                  <span className="p-feedback">
                                    Response Speed
                                  </span>
                                </label>
                                <br />
                                <label>
                                  <input
                                    type="checkbox"
                                    className="challenges"
                                    name="challenges"
                                    value="Onboarding"
                                    onChange={handleChange}
                                  />
                                  <span className="p-feedback">
                                    {" "}
                                    Onboarding
                                  </span>
                                </label>
                              </div>
                            )}

                            <p className="p-feedback">
                              Did Yooki understand your queries correctly?
                            </p>
                            <div className="label-div-feedback">
                              {" "}
                              <label>
                                <input
                                  type="radio"
                                  name="understand"
                                  value="Yes"
                                  required
                                  onChange={handleChange}
                                  style={{ width: "20px" }}
                                />{" "}
                                <span className="p-feedback">Yes</span>
                              </label>
                              <label>
                                <input
                                  type="radio"
                                  name="understand"
                                  value="Partially"
                                  required
                                  onChange={handleChange}
                                  style={{ width: "20px" }}
                                />{" "}
                                <span className="p-feedback">Somewhat</span>
                              </label>
                              <label style={{ marginLeft: "55px" }}>
                                <input
                                  type="radio"
                                  name="understand"
                                  value="No"
                                  required
                                  onChange={handleChange}
                                  style={{ width: "20px" }}
                                />{" "}
                                <span className="p-feedback">No</span>
                              </label>
                            </div>

                            <p className="p-feedback">
                              How accurate were the answers provided?
                            </p>
                            <div className="button-feedback">
                              {[
                                { value: "1", label: "Not Satisfactory" },
                                { value: "2", label: "Needs Improvement" },
                                { value: "3", label: "Average" },
                                { value: "4", label: "Satisfactory" },
                                { value: "5", label: "Highly Satisfied" },
                              ].map((rating) => (
                                <button
                                  key={rating.value}
                                  type="button"
                                  onClick={() => {
                                    setSelected(rating.value);
                                    setFormData((prev) => ({
                                      ...prev,
                                      accuracy: rating.value,
                                    }));
                                  }}
                                  className={`btn-question-feedback  btm-four-wgt${selected === rating.value ? "selected" : ""
                                    }`}
                                  style={{
                                    transition: "all 0.3s ease",
                                    backgroundColor:
                                      selected === rating.value
                                        ? "#5ab4de"
                                        : "#f5f5f5",
                                    color:
                                      selected === rating.value
                                        ? "white"
                                        : "black",
                                    border:
                                      selected === rating.value
                                        ? "1px solid #5ab4de"
                                        : "1px solid #E1E7EA",
                                    transform:
                                      selected === rating.value
                                        ? "scale(1.05)"
                                        : "scale(1)",
                                  }}
                                >
                                  <span className="p-type-title">
                                    {rating.label}
                                  </span>
                                </button>
                              ))}
                            </div>

                            <p className="p-feedback l-para">
                              What would you suggest us to change or improve
                              about Yooki?
                            </p>
                            <textarea
                              className="form-control"
                              name="improvement"
                              rows="3"
                              placeholder="Mention your suggestions"
                              style={{
                                width: "100%",
                                height: "100px",
                                border: "1px solid #E1E7EA",
                                borderRadius: "12px",
                              }}
                              value={formData.improvement}
                              onChange={handleChange}
                            ></textarea>

                            <button
                              className="review-btn logout-button"
                              type="submit"
                              style={{
                                background: "#5ab4de",
                                color: "white",
                                marginTop: "10px",
                                border: "none",
                              }}
                            >
                              Submit
                            </button>
                          </form>
                        </>
                        {loading && (
                          <div className="loader-container">
                            <div className="loader"></div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}

              {/* old promptbutton position */}

              <div className="chat-audioplayer">
                {!showPromptType && !isHistory && <Audioplayer />}
              </div>
              <div>
                {!showPromptType && !isHistory && <Trendingcurrentaffairs />}
              </div>
            </div>
          </div>
          {/* Right sidebar area can be uncommented if needed */}
          {messages.length > 0 ? (
            <div className="right-sidebar-area RelatedTopic-mob"></div>
          ) : null}
          {/* {messages.length > 0 && promptType != "Prelims Practice" && (
            <div style={{ width: "300px" }} className="right-sidebar-area">
            
            </div>
          )} */}
        </div>
      </div>

      {showSharePopup && (
        <div
          className="share-popup"
          ref={popupRef}
          style={{
            position: "absolute",
            top: sharePopupPos.top,
            left: sharePopupPos.left,
            zIndex: 9999,
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="share-buttons-social">
            {/* Copy */}
            <div onClick={handleCopy}>
              <img
                src="/assets/images/copy-1.svg"
                alt="Copy link"
                width={30}
                height={30}
              />
            </div>

            {/* WhatsApp */}
            <div
              onClick={() =>
                window.open(
                  `https://wa.me/?text=${encodeURIComponent(shareUrl)}`,
                  "_blank",
                )
              }
            >
              <img
                src="/assets/images/whatsapp.svg"
                alt="WhatsApp"
                width={30}
                height={30}
              />
            </div>

            {/* Telegram */}
            <div
              onClick={() =>
                window.open(
                  `https://t.me/share/url?url=${encodeURIComponent(shareUrl)}`,
                  "_blank",
                )
              }
            >
              <img
                src="/assets/images/telegram.svg"
                alt="Telegram"
                width={30}
                height={30}
              />
            </div>

            {/* Facebook */}
            <div
              onClick={() =>
                window.open(
                  `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                    shareUrl,
                  )}`,
                  "_blank",
                )
              }
            >
              <img
                src="/assets/images/facebook.svg"
                alt="Facebook"
                width={30}
                height={30}
              />
            </div>

            {/* LinkedIn */}
            <div
              onClick={() =>
                window.open(
                  `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
                    shareUrl,
                  )}`,
                  "_blank",
                )
              }
            >
              <img
                src="/assets/images/linkdine.svg"
                alt="LinkedIn"
                width={30}
                height={30}
              />
            </div>

            {/* X (Twitter) */}
            <div
              onClick={() =>
                window.open(
                  `https://twitter.com/intent/tweet?url=${encodeURIComponent(
                    shareUrl,
                  )}`,
                  "_blank",
                )
              }
            >
              <img src="/assets/images/x.svg" alt="X" width={30} height={30} />
            </div>
          </div>
          {copied && <p className="copy-msg">✅ Link copied!</p>}
        </div>
      )}
    </>
  );
};

export default ChatWindow;
